export default {
    common: {
        actions: '操作',
        add: '新增',
        edit: '修改',
        delete: '删除',
        more: '更多',
        search: '搜索',
        reset: '重置',
        export: '导出',
        submit: '确定',
        confirm: '确定',
        reset: '重置',
        to: '至',
        cancel: '取消',
        info: '提示',
        enable: '启用',
        disable: '停用',
        expand: '展开/折叠',
        close: '关闭',
        startDate: '开始日期',
        endDate: '结束日期',
        to: '至',
        success: '成功',
        warning: '警告',
        error: '错误',
        yes: '是',
        no: '否',
        noData: '暂无数据',
        back: '返回',
        status: '状态',
        createTime: '创建时间',
        updateTime: '更新时间',
        normal: '正常',
        addSuccess: '新增成功',
        editSuccess: '修改成功',
        deleteSuccess: '删除成功',
        selectedCount: '已选 {n} 项',
        clearSelection: '清空选择',
        collapseAll: '全部折叠',
        expandAll: '全部展开',
        keyword: '关键词',
        refresh: '刷新'
    },
    template: {
        private: {
            searchPlaceholder: '请输入模板名称',
            empty: '没有找到模板'
        },
        public: {
            searchPlaceholder: '请输入模板关键词',
            categoryAll: '全部模板',
            defaultCategory: '公共模板',
            use: '使用',
            detail: '详情',
            empty: '暂无模板',
            total: '共 {count} 条',
            previewMissingId: '当前模板缺少项目ID，无法预览',
            copyMissingId: '当前模板缺少项目ID，无法复制',
            copyConfirmMessage: '将以该模板复制新项目并跳转到设计页，是否继续？',
            sameAsSource: '跟源项目一样',
            copyNoResponse: '复制失败：服务无响应',
            copyFailed: '复制失败',
            copySuccessNoId: '复制成功，但未获取到新项目ID',
            copySuccessJump: '复制成功，正在跳转',
            copyFailRetry: '复制失败，请稍后再试'
        },
        preview: {
            headerTitle: '问卷题目预览',
            titleDefault: '问卷预览',
            subtitleDefault: '题目预览（不展示选项）',
            defaultEstimateTime: '5-10分钟',
            questionCount: '共 {count} 道题目',
            estimatedTime: '预计耗时：{time}',
            noOptionsNote: '仅预览题目，不展示选项',
            sectionTitle: '题目列表',
            untitledQuestion: '未命名题目',
            empty: '暂无题目',
            loadFail: '预览加载失败',
            type: {
                TEXT: '问答题',
                TEXTAREA: '多行文本',
                SINGLE: '单选题',
                MULTIPLE: '多选题',
                OPEN: '开放题',
                NUMBER: '数字题',
                DATETIME: '日期题',
                SCORE: '评分题',
                SORT: '排序题',
                UPLOAD: '上传题',
                TIME: '时间题',
                TIMESTAMP: '时间戳',
                SELECT: '下拉选择',
                MATRIX_RADIO: '矩阵单选',
                MATRIX_MULTI: '矩阵多选',
                MATRIX_BLANK: '矩阵填空',
                MATRIX_STATISTICS: '矩阵统计',
                MATRIX_COMPOSITION: '矩阵组合',
                THERMODYNAMIC_CHART: '热力图',
                COMBINATION: '组合题',
                LOOP: '循环题',
                AUTO_RECORD: '自动记录'
            }
        }
    },
    fixdata: {
        title: '补充数据中心',
        add: '新建案例',
        updateData: '更新数据',
        updateDataConfirmTitle: '提示',
        updateDataConfirmMessage: '确认执行数据更新？',
        updateDataConfirmOk: '确认',
        updateDataConfirmCancel: '取消',
        updateDataSuccess: '数据更新成功',
        updateDataFail: '数据更新失败',
        syncQuota: '同步配额',
        syncQuotaPromptTitle: '同步配额',
        syncQuotaPromptMessage: '请输入项目ID',
        syncQuotaPromptPlaceholder: '例如：455',
        syncQuotaPromptOk: '确认',
        syncQuotaPromptCancel: '取消',
        syncQuotaInvalid: '请输入纯数字的项目ID',
        syncQuotaSuccess: '同步配额已触发',
        syncQuotaFail: '同步配额失败',
        search: '搜索',
        searchPlaceholder: '搜索补数名称',
        id: '编号',
        name: '案例名称',
        caseId: '补数编号',
        caseName: '补数名称',
        type: '类型',
        typeFix: '补数',
        typeDiscard: '废弃',
        projectId: '项目ID',
        projectName: '项目名称',
        createdAt: '创建时间',
        recordsCount: '记录数',
        actions: '操作',
        edit: '编辑',
        import: '导入',
        delete: '删除',
        addDialogTitle: '新建案例',
        editDialogTitle: '编辑案例',
        form: {
            name: '案例名称',
            desc: '案例描述',
            ok: '确定',
            save: '保存',
            confirm: '导入'
        },
        upload: {
            rawHint: '将 CSV 或 Excel 文件拖到此处，或',
            clickToUpload: '点击上传',
            rawTip: '仅支持 .csv、.xlsx',
            rawTypeOnly: '仅支持CSV或Excel文件',
            rawSelected: '已选择文件',
            rawSelectFirst: '请先选择文件',
            rawSuccess: '导入成功',
            rawFail: '导入失败'
        },
        importDialogTitle: '导入补充数据',
        message: {
            inputName: '请输入案例名称',
            saved: '保存成功',
            saveFail: '保存失败'
        },
        deletion: {
            confirm: '确认删除【{name}】？',
            success: '删除成功',
            fail: '删除失败'
        }
    },
    ops: {
        common: {
            confirm: '确认',
            cancel: '取消',
            refresh: '刷新'
        },
        data: {
            title: '数据运维',
            projectId: '项目ID',
            projectName: '项目名称',
            remark: '备注',
            isCurrent: '是否当前',
            current: '当前',
            notCurrent: '非当前',
            searchProjectNamePlaceholder: '搜索项目名称',
            searchProjectIdPlaceholder: '搜索项目ID',
            search: '搜索',
            reset: '重置',
            actions: '操作',
            dataVersion: '数据版本',
            import: '导入',
            export: '导出',
            restore: '应用',
            pullData: '拉取数据',
            sync: '同步版本',
            syncConfirmTitle: '提示',
            syncConfirmAll: '确认同步全部项目的初始化备份版本？',
            syncConfirmProject: '确认同步项目 {id} 的初始化备份版本？',
            syncSuccess: '同步已触发',
            syncFail: '同步失败',
            pullConfirmMessage: '确认拉取项目 {id} 的 v1 数据？',
            pullSuccess: '拉取已触发',
            pullFail: '拉取失败',
            listFail: '获取列表失败',
            exportFail: '导出失败',
            restoreFail: '应用失败',
            importFail: '导入失败',
            importSuccess: '导入成功',
            versions: '版本',
            versionsDialogTitle: '项目版本（项目ID：{id}）',
            versionsLoadFail: '获取项目版本失败',
            downloadLatestData: '下载最新数据',
            downloadLatestDataFail: '下载最新数据失败',
            versionId: 'ID',
            createdAt: '创建时间',
            delete: '删除',
            deleteConfirmTitle: '提示',
            deleteConfirmMessage: '确认删除版本记录（ID：{id}）？',
            deleteSuccess: '删除成功',
            deleteFail: '删除失败：{msg}',
            importDialogTitle: '导入版本（项目ID：{id}）',
            importProjectId: '项目ID',
            remarkPlaceholder: '可选',
            importFile: 'Excel文件',
            importDropHint: '将文件拖到此处，或',
            importClick: '点击上传',
            importTip: '仅支持 .xlsx、.xls',
            importFileRequired: '请选择Excel文件',
            selectedFile: '已选择：',
            restoreConfirmTitle: '提示',
            restoreConfirmMessage: '确认应用项目 {id} 的版本 {version}？该操作会覆盖当前数据。',
            restoreSuccess: '应用成功'
        },
        quota: {
            title: '配额缓存管理',
            hint: '用于清除配额相关缓存。数据量较大时可能需要等待。',
            clearAll: '清除全部缓存',
            clearByProject: '按项目清除',
            allProjects: '全部项目',
            clearingTip: '正在清除缓存，请耐心等待...',
            clearSuccess: '缓存清除已触发',
            clearFail: '清除失败：{msg}',
            clearAllConfirmTitle: '提示',
            clearAllConfirmMessage: '确认清除全部项目的配额缓存？',
            projectPromptTitle: '按项目清除',
            projectPromptMessage: '请输入项目ID',
            projectPromptPlaceholder: '例如：455',
            projectInvalid: '请输入纯数字的项目ID',
            logTime: '时间',
            logProjectId: '项目ID',
            logResult: '结果',
            searchProjectNamePlaceholder: '搜索项目名称',
            searchProjectIdPlaceholder: '搜索项目ID',
            search: '搜索',
            reset: '重置',
            projectId: '项目ID',
            projectName: '项目名称',
            projectDesc: '项目描述',
            createTime: '创建时间',
            actions: '操作',
            syncQuota: '同步配额',
            syncingTip: '正在同步配额，请耐心等待...',
            syncConfirmTitle: '提示',
            syncConfirmMessage: '确认同步项目 {id} 的配额？',
            syncSuccess: '同步已触发',
            syncFail: '同步失败：{msg}',
            listFail: '获取列表失败'
        },
        activityMonitor: {
            title: '问卷活跃监控',
            window: '活跃窗口',
            win3h: '3小时',
            win6h: '6小时',
            win12h: '12小时',
            win1d: '1天',
            win3d: '3天',
            win5d: '5天',
            unitHour: '小时',
            unitDay: '天',
            unitWeek: '周',
            apply: '应用',
            windowInvalid: '请输入有效的窗口范围',
            projectId: '项目ID',
            projectName: '项目名称',
            projectStatus: '项目状态',
            statusRun: '运行中',
            lastActiveTime: '最后活跃时间',
            activeAnswerCount: '活跃答卷数',
            windowMinutes: '窗口',
            listFail: '获取列表失败'
        },
        dataAdjust: {
            title: '数据调整',
            searchProjectIdPlaceholder: '请输入项目ID',
            search: '搜索',
            reset: '重置',
            add: '添加',
            addDialogTitle: '添加调整记录',
            selectProject: '选择项目',
            selectPlaceholder: '输入项目名称搜索',
            loadProjectsFail: '获取项目列表失败',
            downloadLatestData: '下载最新数据',
            downloadLatestDataFail: '下载最新数据失败',
            exportOrigin: '导出原始',
            exportAdjust: '导出调整',
            exportFail: '导出失败',
            switchToOrigin: '切换到调整前',
            switchToAdjust: '切换到调整后',
            editMode: '编辑模式',
            exitEdit: '退出编辑',
            editOnlyAdjust: '请先切换到调整后再编辑',
            addSuccess: '添加成功',
            addFail: '添加失败',
            projectIdRequired: '请先输入项目ID',
            summaryTitle: 'done 答案汇总',
            sourceOrigin: '原始数据',
            sourceAdjust: '调整后数据',
            questionNo: '题号',
            questionType: '题型',
            questionId: '题目ID',
            total: '总数',
            valuesCount: '答案种类',
            value: '答案值',
            count: '数量',
            summaryFail: '获取汇总失败',
            recordsTitle: '调整记录',
            recordId: '记录ID',
            projectId: '项目ID',
            projectName: '项目名称',
            createTime: '创建时间',
            updateTime: '更新时间',
            actions: '操作',
            adjust: '调整',
            adjustDialogTitle: '答案统计（项目ID：{id}）',
            listFail: '获取列表失败'
        }
    },
    olddata: {
        title: '历史数据',
        add: '增加',
        searchPlaceholder: '搜索项目名称',
        search: '搜索',
        refresh: '刷新',
        id: '项目编号',
        name: '项目名称',
        type: '类型',
        typeOld: '旧数据',
        industry: '行业',
        company: '公司',
        desc: '项目描述',
        questionCount: '题目数目',
        answerCount: '答案数目',
        actions: '操作',
        preview: '预览',
        edit: '编辑',
        view: '查看',
        delete: '删除',
        addDialogTitle: '新增导入项目',
        editDialogTitle: '编辑项目',
        form: {
            name: '项目名称',
            desc: '项目描述',
            company: '公司名称',
            companyPlaceholder: '请输入公司名称',
            category: '分类标签',
            categoryPlaceholder: '请选择分类',
            dataZip: '数据ZIP',
            dataImported: '数据已导入',
            dataCount: '{count} 条',
            clear: '清空',
            rawData: '原始数据',
            next: '下一页',
            save: '保存',
            ok: '确定',
            prev: '上一页',
            confirm: '确认'
        },
        upload: {
            zipHint: '拖拽ZIP到此处，或',
            clickToUpload: '点击上传',
            zipTip1: '仅支持 .zip，上传后将更新条目数',
            zipTip2: '压缩包需包含 asc 文件与 datamap.txt',
            zipOnly: '仅支持上传ZIP文件',
            zipSuccess: '旧数据导入成功',
            zipFail: '旧数据导入失败',
            rawHint: '拖拽原始数据到此处，或',
            rawTip: '支持 Excel（.xlsx/.xls）与 .csv',
            rawSelectFirst: '请先选择原始数据文件',
            rawSuccess: '原始数据导入成功',
            rawFail: '原始数据导入失败',
            rawTypeOnly: '仅支持 .csv/.xlsx/.xls 文件',
            rawSelected: '已选择原始数据文件，请点击确认导入'
        },
        clear: {
            confirm: '确认清空已导入数据？',
            success: '已清空',
            fail: '清空失败'
        },
        deletion: {
            confirm: '确认删除项目「{name}」？删除后不可恢复',
            success: '已删除',
            fail: '删除失败'
        },
        previewDialog: {
            title: '项目预览',
            name: '名称',
            desc: '描述',
            tags: '标签',
            createdAt: '创建时间',
            updatedAt: '更新时间',
            rowsCount: '条目数',
            close: '关闭',
            viewData: '查看数据'
        },
        message: {
            fetchListFail: '获取旧数据项目列表失败',
            inputName: '请输入名称',
            saved: '已保存修改',
            createSuccess: '创建成功',
            createFail: '创建失败',
            refreshed: '已刷新列表'
        },
        detail: {
            back: '返回',
            itemsTag: '条目 {count}',
            cross: '交叉分析',
            exportCsv: '导出CSV',
            selectQuestionPlaceholder: '选择题号',
            answerKeywordPlaceholder: '输入答案关键词',
            search: '搜索',
            text: '文本',
            value: '值',
            status: '状态',
            statusValues: {
                completed: '完成',
                inProgress: '进行中',
                failed: '失败'
            },
            crossDialog: {
                title: '交叉分析',
                demo: '该功能还在开发中，敬请期待',
                close: '关闭',
                ok: '确定'
            },
            message: {
                fetchAnswersFail: '获取答题数据失败',
                fetchProjectFail: '获取项目详情失败'
            }
        }
    },
    route: {
        dashboard: '后台管理系统',
        usermanger:'用户中心',


        introduction: '简述',
        documentation: '文档',
        permission: '权限测试页',
        pagePermission: '页面权限',
        directivePermission: '指令权限',
        icons: '图标',
        components: '组件',
        componentIndex: '介绍',
        tinymce: '富文本编辑器',
        markdown: 'Markdown',
        jsonEditor: 'JSON编辑器',
        dndList: '列表拖拽',
        splitPane: 'Splitpane',
        avatarUpload: '头像上传',
        dropzone: 'Dropzone',
        sticky: 'Sticky',
        countTo: 'CountTo',
        componentMixin: '小组件',
        backToTop: '返回顶部',
        dragDialog: '拖拽 Dialog',
        dragKanban: '可拖拽看板',
        charts: '图表',
        keyboardChart: '键盘图表',
        lineChart: '折线图',
        mixChart: '混合图表',
        example: '综合实例',
        Table: 'Table',
        dynamicTable: '动态Table',
        dragTable: '拖拽Table',
        inlineEditTable: 'Table内编辑',
        complexTable: '综合Table',
        treeTable: '树形表格',
        customTreeTable: '自定义树表',
        tab: 'Tab',
        form: '表单',
        createForm: '创建表单',
        editForm: '编辑表单',
        errorPages: '错误页面',
        page401: '401',
        page404: '404',
        errorLog: '错误日志',
        excel: 'Excel',
        exportExcel: 'Export Excel',
        selectExcel: 'Export Selected',
        uploadExcel: 'Upload Excel',
        zip: 'Zip',
        exportZip: 'Export Zip',
        theme: '换肤',
        clipboardDemo: 'Clipboard',
        i18n: '国际化'
    },
    navbar: {
        logOut: '退出登录',
        dashboard: '首页',
        // 侧边栏分组标题与环境标识
        groupDaily: '日常',
        groupConfig: '配置',
        groupAdvanced: '高级',
        envProd: '生产',
        envTest: '测试',
        envUnknown: '未知环境',
        github: '项目地址',
        screenfull: '全屏',
        theme: '换肤',
        projectManagement: '项目管理',
        recycleBin: '回收中心',
        systemManagement: '系统管理',
        userManagement: '用户管理',
        roleManagement: '角色管理',
        menuManagement: '菜单管理',
        codeGeneration: '代码生成',
        projectList: '项目列表',
        automatedReport: '自动化报告',
        favoritesCenter: '收藏中心',
        collaborativeSurvey: '协作问卷',
        pushCenter: '推送中心',
        systemSettings: '系统配置'
    },
    login: {
        title: '系统登录',
        logIn: '登录',
        username: '账号',
        password: '密码',
        any: '随便填',
        thirdparty: '第三方登录',
        thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
    },
    publicSite: {
        navigation: '易调研系统公共导航',
        brandName: '易调研系统',
        brandAlt: '易调研系统 Logo',
        brandSubtitle: 'YiSurvey Platform',
        home: '首页',
        capabilities: '产品能力',
        pricing: '价格',
        contact: '联系我们',
        login: '登录',
        register: '注册'
    },
    landingPage: {
        revealEyebrow: 'Survey Intelligence Online',
        taglinePlain: '让每一个问题，变成可行动的洞察',
        heroEyebrow: 'Survey Intelligence Platform',
        productName: '易调研系统',
        heroTagline: '让每一个问题，变成可行动的洞察。',
        heroDescription: '从问卷设计、样本投放、配额监控到数据洞察，把复杂调研流程压缩进一个清晰、可协作、可追踪的系统。',
        demoCta: '预约演示',
        pricingCta: '查看价格',
        dashboardCta: '进入工作台',
        heroProofs: ['问卷设计', '样本配额', '实时监控', '数据洞察'],
        engineTitle: 'Survey Intelligence Engine',
        engineLabel: '有效样本信号',
        stage: {
            questionKicker: '问卷设计',
            questionTitle: '品牌认知调研',
            sampleKicker: '样本流转',
            responseCount: '2,847 份答卷',
            quotaKicker: '配额监控',
            quotaLabel: '区域 / 年龄 / 渠道',
            insightKicker: '实时洞察',
            logicChip: '智能逻辑',
            cleanChip: '清洗数据'
        },
        workflowEyebrow: 'YiSurvey Workflow',
        workflowTitle: '从项目创建，到报告产出，全流程都在一个系统里推进。',
        workflowDescription: '项目进入易调研系统后，可以完成问卷设计、发布回收、配额监控、数据补充、统计下载和专题分析，让调研团队少切换工具，多沉淀资产。',
        visual: {
            projectQuestion: '把所有调研项目，先放进一个可追踪的工作台。',
            projectTags: ['创建项目', '题量统计', '回收进度', '分享码复制'],
            logicTitle: '逻辑控制',
            logicPreview: '跳转 / 复制 / 脚本预览',
            designChannels: ['基础题型', '循环题', 'MaxDiff', 'AI 脚本', '多语言'],
            launchLabel: '发布 / 配额 / 邮件',
            quotaBadge: '配额完成监控',
            analysisLabel: '数据 / 分析 / 报告',
            insightHeadline: '数据查看、补充修正、统计下载和专题分析一起收口。',
            analysisActions: ['Excel / SPSS', '音频下载', '补充数据', '开放题分析', '自动化报告']
        },
        evidenceEyebrow: 'Evidence Chain',
        evidenceTitle: '让每一个问题，变成可行动的洞察。',
        evidenceDescription: '一份调研不是靠一个漂亮大屏被证明，而是从立项、问卷、发布、配额、数据到分析，每一步都有可追溯的交付物。',
        caseFileTitle: '新品包装认知调研',
        caseFileMeta: ['28 题', '1,426 份答卷', '6 个配额维度'],
        caseFileStamp: '可追溯',
        useCaseEyebrow: 'Use Cases',
        useCaseTitle: '从一次包装测试，',
        useCaseTitleAccent: '到长期品牌追踪。',
        useCaseDescription: '易调研系统适合承接需要设计问卷、控制样本、沉淀数据并交付分析结果的项目；不同场景使用同一条调研作业链路，但保留各自的交付痕迹。',
        scenarioBoardLabel: 'Research Scenario Board',
        sharedFlowLabel: '共同链路',
        sharedFlowValue: '问卷设计 / 发布回收 / 配额监控 / 数据交付',
        contactEyebrow: 'Demo Access',
        contactTitle: '准备把调研流程接入易调研系统？',
        contactDescription: '先预约演示，或进入价格页了解不同团队规模的方案。',
        scenes: {
            project: {
                label: 'Project Hub',
                title: '项目先进入统一工作台。',
                desc: '新建、复制、移动、关闭、延期和回收站管理都围绕项目展开；题量、投放量和完成数直接回到项目列表里。',
                points: ['项目创建', '文件夹归档', '题量 / 回收统计']
            },
            design: {
                label: 'Question Designer',
                title: '复杂问卷在设计器里完成。',
                desc: '基础题型、逻辑设置、题型切换、循环题、MaxDiff、前中后置脚本、AI 脚本、多语言和资源管理集中在同一个设计界面。',
                points: ['题型组件', '逻辑 / 脚本', '循环题 / MaxDiff']
            },
            launch: {
                label: 'Launch Control',
                title: '发布、链接、配额和触达同步推进。',
                desc: '项目发布、历史链接、链接配置、配额方案、配额监控、邮件模板、发件人、名单分组和发送记录共同支撑回收执行。',
                points: ['发布链接', '配额方案', '邮件触达']
            },
            analysis: {
                label: 'Data & Report',
                title: '数据回收后还能继续处理和分析。',
                desc: '答卷数据、统计视图、Excel / SPSS / 音频下载、补充数据、配额同步、开放题分析、品名测试、试吃分析和自动化报告形成闭环。',
                points: ['数据下载', '补充数据', '专题分析']
            }
        },
        evidenceSteps: {
            project: {
                label: 'Project Brief',
                title: '项目立项',
                desc: '项目名称、状态、文件夹、题量和答卷量先被归档。',
                artifacts: ['项目列表', '状态筛选', '分享码']
            },
            questionnaire: {
                label: 'Questionnaire',
                title: '问卷结构',
                desc: '题型组件、大纲、题库、循环题和 MaxDiff 形成可编辑结构。',
                artifacts: ['题型组件', '大纲', 'MaxDiff']
            },
            launch: {
                label: 'Launch Link',
                title: '发布回收',
                desc: '发布项目、历史链接、链接配置和邮件触达绑定同一项目。',
                artifacts: ['发布链接', '历史链接', '邮件模板']
            },
            quota: {
                label: 'Quota Record',
                title: '配额记录',
                desc: '样本状态、成功率、配额方案和矩阵表保留执行过程。',
                artifacts: ['样本统计', '配额矩阵', '完成率']
            },
            dataset: {
                label: 'Dataset',
                title: '数据交付',
                desc: '答卷查看、补充数据、Excel / SPSS / 音频下载进入交付包。',
                artifacts: ['Excel', 'SPSS', '音频']
            },
            insight: {
                label: 'Insight',
                title: '专题分析',
                desc: '开放题、品名测试和试吃分析承接数据后的判断。',
                artifacts: ['开放题', '品名测试', '试吃分析']
            }
        },
        useCases: {
            brand: {
                label: 'Brand & Package',
                period: '2-4 周',
                title: '品牌与包装测试',
                desc: '验证消费者看到包装、概念或品牌信息后的认知、偏好、购买意愿和开放反馈。',
                flow: ['包装概念', '认知偏好', '开放反馈'],
                deliverables: ['Excel / SPSS', '开放题分析', '结论沉淀']
            },
            trial: {
                label: 'Product Trial',
                period: '现场 / 入户',
                title: '新品试吃与产品测试',
                desc: '围绕配额筛选、体验记录、品名测试和试吃维度分析，支撑产品上市前判断。',
                flow: ['配额筛选', '体验记录', '产品对比'],
                deliverables: ['配额监控', '试吃分析', '品名测试']
            },
            tracking: {
                label: 'Tracking Study',
                period: '月度 / 季度',
                title: '长期品牌追踪',
                desc: '复用历史项目、题库、术语和数据版本，把周期性回收变成可对比的趋势资产。',
                flow: ['项目复制', '周期回收', '趋势沉淀'],
                deliverables: ['历史链接', '数据版本', '周期报告']
            }
        }
    },
    loginPage: {
        kickedTitle: '账号在别处登录',
        kickedDesc: '您的账号已在其他设备登录，本设备已被迫下线。如非本人操作，请立即修改密码。',
        loginTitle: '登录',
        username: '用户名',
        usernameLogin: '用户名/手机号',
        loginModePassword: '密码登录',
        loginModeSms: '短信验证码登录',
        loginModeLabel: '登录方式',
        password: '密码',
        forgotPassword: '忘记密码？',
        login: '登录',
        orLoginWith: '或使用社交平台登录',
        registerTitle: '注册',
        register: '注册',
        orRegisterWith: '或使用社交平台注册',
        hello: '你好，欢迎',
        noAccount: '还没有账号？',
        toRegister: '注册',
        welcomeBack: '欢迎回来！',
        hasAccount: '已经有账号？',
        toLogin: '登录',
        usernameRequired: '请输入用户名',
        usernameInvalid: '用户名需包含字母',
        passwordRequired: '请输入密码',
        loginSuccess: '登陆成功',
        loginFailed: '登录失败，请稍后重试',
        invalidCredentials: '用户名或密码错误',
        accountNotFound: '用户名不存在',
        mobileNotRegistered: '该手机号尚未注册',
        passwordIncorrect: '密码错误',
        pricingPlans: '收费标准',
        authEyebrow: 'YiSurvey / PUBLIC ACCESS',
        authHeadlinePrimary: '从一个问题开始，',
        authHeadlineAccent: '把答案带回团队。',
        authDescription: '登录易调研系统，继续管理问卷、样本、回收数据与调研洞察。',
        flowQuestionnaire: '问卷设计',
        flowLaunch: '发布触达',
        flowCollection: '数据回收',
        flowInsight: '洞察交付',
        workspaceReady: '工作台已就绪',
        workspaceTraceable: '过程可追踪',
        workspaceCollaborative: '团队可协作',
        authModeLabel: '登录或注册',
        loginKicker: 'RETURN TO YOUR WORKSPACE',
        registerKicker: 'START A NEW STUDY',
        loginSubtitle: '使用你的账号继续调研工作。',
        registerSubtitle: '创建账号，开始组织下一次调研。',
        usernamePlaceholder: '用户名/手机号',
        passwordPlaceholder: '输入密码',
        mobile: '手机号',
        mobilePlaceholder: '输入手机号',
        mobileRequired: '请填写手机号',
        mobileInvalid: '请输入有效的中国大陆手机号',
        smsCode: '手机验证码',
        smsCodePlaceholder: '输入验证码',
        smsCodeRequired: '请输入手机验证码',
        smsCodeInvalid: '手机验证码无效或已过期',
        sendSmsCode: '获取验证码',
        smsCountdown: '{seconds}s 后重发',
        smsSent: '验证码已发送，请注意查收',
        smsTooFrequent: '验证码发送过于频繁，请稍后再试',
        smsSendFailed: '验证码发送失败，请稍后重试',
        email: '邮箱',
        emailOptional: '邮箱（选填）',
        emailPlaceholder: '输入工作邮箱',
        emailRequired: '请输入邮箱',
        emailInvalid: '请输入有效的邮箱地址',
        loggingIn: '登录中...',
        registering: '注册中...',
        contactSupport: '登录遇到问题？联系支持',
        supportSubject: '易调研系统登录支持',
        registerSuccess: '注册成功，请使用新账号登录',
        registerFailed: '注册失败，请稍后重试',
        mobileExists: '手机号已被注册',
        accountExists: '账号、手机号或邮箱已存在'
    },
    documentation: {
        documentation: '文档',
        github: 'Github 地址'
    },
    // ===== 实时协同（编辑端 WebSocket）=====
    collab: {
        online: '在线协作者',
        someone: '协作者',
        updated: '更新了',
        isEditing: '正在编辑',
        updatedBadge: '已被 {name} 更新',
        loadLatest: '加载最新',
        overwrite: '用我的版本覆盖',
        loadLatestBtn: '加载对方的版本',
        conflictTitle: '保存冲突',
        conflictDesc: '该题已被其他协作者修改，你的本次修改尚未保存。',
        conflictTip: '「用我的版本覆盖」将以你的内容替换对方的修改；「加载对方的版本」将放弃你的本次修改。',
        overwriteSuccess: '已覆盖保存',
        overwriteFail: '覆盖保存失败',
        loadedLatest: '已加载对方的最新版本',
        reconnecting: '实时协同连接中断，正在重连…',
        degraded: '实时协同暂不可用（将自动重试）'
    },
    permission: {
        roles: '你的权限',
        switchRoles: '切换权限'
    },
    components: {
        documentation: '文档',
        tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
        dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
        stickyTips: '当页面滚动到预设的位置会吸附在顶部',
        backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
        backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
        imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
    },
    table: {
        dynamicTips1: '固定表头, 按照表头顺序排序',
        dynamicTips2: '不固定表头, 按照点击顺序排序',
        dragTips1: '默认顺序',
        dragTips2: '拖拽后顺序',
        title: '标题',
        importance: '重要性',
        type: '类型',
        remark: '点评',
        reviewer: '审核人',
        id: '序号',
        date: '时间',
        author: '作者',
        readings: '阅读数',
        status: '状态',
        publish: '发布',
        draft: '草稿',
    },
    errorLog: {
        tips: '请点击右上角bug小图标',
        description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
        documentation: '文档介绍'
    },
    excel: {
        export: '导出',
        selectedExport: '导出已选择项',
        placeholder: '请输入文件名(默认excel-list)'
    },
    zip: {
        export: '导出',
        placeholder: '请输入文件名(默认file)'
    },
    theme: {
        change: '换肤',
        documentation: '换肤文档',
        tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
    },
    tagsView: {
        close: '关闭',
        closeOthers: '关闭其它',
        closeAll: '关闭所有'
    },
    dashboard: {
        kpi: {
            surveyCount: "问卷数",
            userCount: "用户数",
            ongoingSurvey: "进行中的问卷",
            recoveryRate: "问卷回收率"
        },
        hero: {
            badge: "YISURVEY · SMART SURVEY SYSTEM",
            title: "一体化问卷设计与数据洞察平台",
            desc: "支持问卷编辑、复杂逻辑编排、脚本扩展、样本与配额管理，帮助团队快速构建高质量调研项目并持续追踪效果。",
            enterProjectList: "进入项目列表",
            signalRealtime: "实时回收",
            signalSmart: "智能甄别",
            cube: {
                survey: "问卷",
                sample: "样本",
                logic: "逻辑",
                quota: "配额",
                insight: "洞察",
                analysis: "分析"
            }
        },
        entry: {
            editorTitle: "问卷编辑器",
            editorDesc: "可视化搭建题型结构，支持题目批量维护、模板复用与多语言扩展。",
            logicTitle: "逻辑与脚本能力",
            logicDesc: "支持跳转逻辑、显示条件、配额规则与脚本处理，满足复杂业务场景。",
            deliveryTitle: "投放与分析闭环",
            deliveryDesc: "覆盖链接投放、样本回收、质量甄别与结果分析，提升整体调研效率。"
        },
        trend: "数据趋势统计",
        client: "客户端",
        browser: "浏览器",
        system: "系统",
        newSurvey: "新问卷",
        announcement: "公告"
    },
    project: {
        collaborator: {
            sharedWithMe: '与我共享',
            readonly: '只可查看',
            share: '共享',
            view: '查看',
            sharedFrom: '共享自',
            title: '共享项目',
            tip: '被共享的成员可以查看该项目的最新内容（题目、配置、答卷、统计），但不能修改项目。',
            searchPlaceholder: '输入用户账号或姓名搜索（至少2个字符）',
            search: '搜索',
            searchResult: '搜索结果',
            invite: '邀请',
            memberList: '已共享成员',
            emptyMembers: '暂未共享给任何人',
            emptySearch: '没有找到匹配的用户',
            remove: '移除',
            close: '关闭',
            readonlyTip: '该项目仅向您开放查看权限，您可以浏览全部内容，但不能修改',
            needKeyword: '请输入至少2个字符',
            inviteSuccess: '已共享给该用户',
            inviteFail: '共享失败',
            removeSuccess: '已移除该成员',
            removeFail: '移除失败',
            sidebarReadonlyTip: '仅查看共享：可以浏览内容，不能修改',
            bannerPrefix: '该项目由',
            bannerSuffix: '共享给您，您可以查看全部内容（含答卷与统计），但不能修改。',
            otherUser: '其他用户',
            tip2: '被邀请的成员需要确认后才可查看该项目。确认后可以查看题目、配置、答卷和统计，但不能修改。',
            inviteSent: '邀请已发送，等待对方确认',
            statusPending: '待确认',
            statusAccepted: '已加入',
            statusRejected: '已拒绝',
            reinvite: '重新邀请',
            invitePanelTitle: '您有新的项目共享邀请',
            collapse: '收起',
            expand: '展开',
            invitedBy: '来自',
            accept: '接受',
            reject: '拒绝',
            acceptSuccess: '已接受邀请，项目已加入您的列表',
            acceptFail: '接受邀请失败',
            rejectSuccess: '已拒绝该邀请',
            rejectFail: '拒绝邀请失败',
            searchFailed: '搜索失败',
            tip3: '按模块为成员配置权限：「只可查看」的模块只能浏览内容，「可编辑」的模块可以修改。被邀请人确认后生效；未授权的模块对方完全不可见。',
        },
        permission: {
            module: '模块',
            none: '无权限',
            read: '只可查看',
            write: '可编辑',
            editButton: '修改权限',
            configTitle: '配置权限',
            configTitleEdit: '修改权限',
            save: '保存',
            saveSuccess: '权限已更新',
            saveFail: '权限更新失败',
            defaultTip: '默认全部为「只可查看」；请按需要调整各模块档位后再发送邀请。',
            pureReadOnlyTip: '「数据下载」「统计分析」为查看类模块，没有「可编辑」档位。',
            dataWriteTip: '「数据」选「可编辑」才能修改问卷状态、删除问卷（含数据页「批量运维」）；选「只可查看」只能浏览答卷。',
            moreItems: '等 {n} 项',
            modules: {
                design: '编辑问卷',
                setting: '问卷设置',
                data: '数据',
                download: '数据下载',
                statistics: '统计分析',
                quota: '配额管理',
                report: '报表',
                publish: '发布与收集'
            }
        },
        transfer: {
            title: '转移项目',
            action: '转移',
            ownerLabel: '项目所有者',
            tipShort: '转移后该项目的所有者会变更，您将不再拥有该项目的管理权限。',
            tip: '转移后，该项目的所有者会变更为新用户，您将立即失去该项目的全部访问权（含只读查看）。此操作不可撤销。',
            projectCount: '待转移项目数',
            newOwner: '新所有者',
            searchPlaceholder: '输入用户账号或姓名搜索（至少2个字符）',
            search: '搜索',
            searchResult: '搜索结果',
            select: '选择',
            change: '更换',
            emptySearch: '没有找到匹配的用户',
            needKeyword: '请输入至少2个字符',
            noProject: '请先选择要转移的项目',
            searchFailed: '搜索失败',
            confirm: '确认转移',
            confirmTitle: '确认转移项目',
            confirmMessage: '确定要把 {count} 个项目转移给 {name} 吗？转移后您将失去这些项目的全部访问权，且此操作不可撤销。',
            success: '已转移 {count} 个项目',
            fail: '转移失败',
        },
        id: "项目ID",
        name: "项目名",
        status: "状态",
        createTime: "创建时间",
        creator: "创建人",
        all: "全部",
        design: "设计中",
        progress: "发布中",
        completed: "已结束",
        expireOverlayText: '项目已过期，请选择关闭或延期',
        extendProject: '确认延期',
        closeProject: '确认关闭',
        extendSuccess: '延期成功',
        extendFail: '延期失败',
        closeSuccess: '项目已关闭',
        closeFail: '关闭失败',
        closeProjectTitle: '关闭项目',
        closeProjectTip: '关闭后问卷链接将无法访问，确定关闭？',
        noData: "暂无数据",
        stats: "统计",
        search: "搜索",
        quotaMonitor: '配额监控',
        report: '报表',
        metrics: {
            questions: '题目',
            launch: '投放',
            answers: '答案'
        },
        folder: {
            more: '更多',
            newFolder: '新建文件夹',
            rename: '重命名',
            adjustOrder: '调整排序',
            cancelClassification: '取消分类',
            assignToFolder: '添加到分类',
            createFolderTitle: '新建文件夹',
            editFolderTitle: '编辑文件夹',
            sortFolderTitle: '调整排序',
            assignToFolderTitle: '添加到分类',
            nameLabel: '名称',
            sortLabel: '排序',
            selectFolderLabel: '选择文件夹',
            selectFolderPlaceholder: '选择文件夹'
        },
        quotaMonitorView: {
            title: '配额监控',
            panelFilterLabel: '选择panel',
            panelAll: '全部',
            panelPlaceholder: '请选择panel',
            refresh: '刷新数据',
            back: '返回',
            noQuota: '配额未启用',
            noQuotaTip: '请先配置并开启配额控制，再开始收集样本',
            currentAnswerCount: '当前答题数',
            quotaStatus: '配额状态',
            enabled: '已开启',
            disabled: '未开启',
            schemeDetails: '配额方案详情',
            matrixDetails: '配额矩阵详情',
            option: '选项',
            quotaFull: '配额已满',
            noSchemeData: '暂无配额方案数据',
            loadFail: '配额数据加载失败',
            retry: '重试',
            messages: {
                dataRefreshed: '数据已刷新'
            }
        },
        sampleStatistics: {
            title: '样本统计',
            success: '成功样本量',
            overQuota: '超配额样本量',
            screened: '甄别样本量',
            unfinished: '未完成样本量',
            discarded: '废弃样本量',
            totalClicks: '链接点击量',
            successRate: '成功率',
            loadFail: '样本统计加载失败'
        },
        config: {
            config: '配置',
            info: '信息',
            link: '链接',
            settings: '设置',
            thirdParty: '第三方配置',
            language: '语言',
            display: '显示',
            status: '状态',
            quota: '配额',
            share: '分享',
            baseInfo: '基本信息',
            projectName: '项目名称',
            projectDescription: '项目描述',
            organization: '所属组织',
            creator: '所属作者',
            createTime: '创建时间',
            updateTime: '更新时间',
            save: '保存',
            linkSettings: '链接设置',
            surveyLink: '问卷链接',
            shareLink: '分享链接',
            copy: '复制',
            baseSettings: '基本设置',
            surveyStatus: '问卷状态',
            on: '开启',
            off: '关闭',
            allowRepeat: '允许重复提交',
            showProgress: '显示进度条',
            thirdPartyIntegration: '第三方集成',
            wechat: '微信集成',
            workWechat: '企业微信',
            dingtalk: '钉钉',
            languageSettings: '语言设置',
            defaultLanguage: '默认语言',
            supportedLanguages: '支持语言',
            zhCN: '简体中文',
            enUS: 'English',
            displaySettings: '显示设置',
            themeColor: '主题色',
            fontSize: '字体大小',
            showLogo: '显示Logo',
            projectStatus: '项目状态',
            currentStatus: '当前状态',
            startTime: '开始时间',
            endTime: '结束时间',
            quotaManage: '配额管理',
            surveyLimit: '问卷配额',
            storageLimit: '存储空间',
            apiLimit: 'API调用次数',
            unitMB: 'MB',
            linkCopied: '链接已复制到剪贴板',
            saving: '配置已保存',
            copySuccess: '复制成功',
            copyFailed: '复制失败',
            saveSuccess: '保存成功',
            saveFailed: '保存失败',
            fetchInfoFail: '获取项目信息失败',
            finishConfirmTitle: '设置项目为已结束',
            finishConfirmMessage: '将项目状态设置为“已结束”后，线上问卷将会被锁定，无法继续答题或修改。是否继续？',
            finishConfirmButton: '继续保存',
            ongoing: '进行中',
            finished: '已结束',
            paused: '已暂停',
            deleted: '已删除',
        },
        share: {
            generateTitle: '生成分享码',
            sourceProjectId: '源项目ID',
            keepLogic: '保留逻辑',
            keepScript: '保留脚本',
            keepI18n: '保留国际化',
            keepPanel: '保留面板',
            keepQuota: '保留配额',
            generate: '生成',
            generateSuccess: '生成成功',
            generateFail: '生成失败',
            shareCode: '分享码',
            copy: '复制',
            copyTitle: '从分享码复制项目',
            inputShareCode: '分享码',
            shareCodePlaceholder: '粘贴 shareCode（body.sig）',
            newProjectName: '新项目名称',
            projectNameOptional: '可选：不填则使用“源项目名_copy”',
            description: '项目描述',
            descriptionPlaceholder: '可选',
            organization: '所属组织',
            organizationPlaceholder: '可选',
            copyAction: '复制项目',
            copySuccess: '复制成功',
            copyFail: '复制失败'
        },
        linkConfig: {
            refresh: '刷新',
            latestLinks: '最新链接',
            historyLinks: '历史链接',
            noLinks: '暂无{type}',
            filterLabel: '筛选条件',
            selectTypePlaceholder: '选择类型',
            all: '全部',
            prod: '正式',
            test: '测试',
            offline: '离线',
            columns: {
                id: 'ID',
                linkUrl: '链接地址',
                type: '类型',
                createTime: '创建时间',
                status: '状态',
                version: '版本',
                tags: '标签',
                actions: '操作'
            },
            tags: {
                idCtrl: '问卷ID控制',
                ipCtrl: 'IP控制',
                guidCtrl: 'GUID控制',
                breakpointCtrl: '答题断点控制',
                isNav: '显示导航栏',
                isPre: '显示上一题按钮',
                isAgain: '线下链接报别重答',
                offline: '线下链接报别重答',
                isTest: '测试'
            },
            noLatestLinks: '未找到链接',
            noHistoryLinks: '没有历史链接',
            loadFail: '加载链接失败',
            loadHistoryFail: '加载历史链接失败',
            testLink: '测试链接',
            prodLink1: '正式链接1',
            prodLink2: '正式链接2',
            offlineVersion: '离线版本',
            custom: '自定义',
            unknownLink: '未知链接',
            disableConfirm: '确定要禁用此链接吗？',
            disableConfirmTitle: '禁用链接确认',
            disableConfirmButton: '确定禁用',
            enableConfirm: '确定要启用此链接吗？',
            enableConfirmTitle: '启用链接确认',
            enableConfirmButton: '确定启用',
            version: '版本',
            typeLabel: '类型',
            category: '分类',
            enabledTip: '链接已启用',
            disabledTip: '链接已禁用',
            operationFail: '操作失败，请重试'
        },
        languageConfig: {
            enableI18n: '开启国际化',
            modeLabel: '开启国际化',
            modeOff: '不开启',
            modeMulti: '多语言',
            modeSingle: '单语言',
            selectDefaultPlaceholder: '请选择默认语言',
            fetchFail: '获取语言配置失败',
            defaultMustInSupported: '默认语言必须在支持的语言列表中',
            supportedRequired: '请选择至少一种支持语言',
            saveSuccess: '语言配置保存成功',
            saveFail: '保存语言配置失败',
            langNames: {
                cn: '中文',
                zh_TW: '繁体中文',
                cantonese: '粤语',
                en: '英文',
                th: '泰文',
                fr: '法语',
                ru: '俄语',
                ar: '阿拉伯语',
                es: '西班牙语',
                de: '德语',
                pt: '葡萄牙语',
                jp: '日语',
                hi: '印地语',
                it: '意大利语',
                pl: '波兰语',
                ms: '马来语',
                vi: '越南语',
                tl: '他加禄语',
                id: '印尼语',
                my: '缅甸语',
                ko: '韩语',
                la: '拉丁语',
            }
        },
        quotaSchemeList: {
            backToProjectConfig: '返回项目配置',
            title: '配额方案管理',
            listTitle: '配额方案列表',
            refresh: '刷新',
            refreshSuccess: '刷新成功',
            create: '新建配额方案',
            loading: '加载中...',
            emptyTitle: '暂无配额方案',
            emptyDesc: '创建您的第一个配额方案来开始管理问卷配额',
            emptyHint: '点击右侧按钮创建第一个配额方案',
            noDescription: '暂无描述',
            totalQuota: '总配额',
            usedQuota: '已使用',
            configureQuota: '配置配额',
            configured: '已配置',
            dialog: {
                createTitle: '创建配额方案',
                editTitle: '编辑配额方案',
                addControlTitle: '新增配额控制',
                create: '创建',
                save: '保存'
            },
            form: {
                name: '方案名称',
                description: '方案描述',
                status: '启用状态',
                namePlaceholder: '请输入配额方案名称',
                descriptionPlaceholder: '请输入配额方案描述（可选）',
                rules: {
                    nameRequired: '请输入方案名称',
                    nameLength: '长度在 2 到 50 个字符'
                }
            },
            messages: {
                loadFail: '加载配额方案失败',
                copySuccess: '配额方案复制成功',
                copyFail: '复制配额方案失败',
                deleteConfirmText: '确定要删除配额方案"{name}"吗？',
                deleteConfirmTitle: '确认删除',
                deleteSuccess: '删除成功',
                deleteFail: '删除失败',
                createSuccess: '创建成功',
                updateSuccess: '更新成功',
                createFail: '创建失败',
                updateFail: '更新失败'
            },
            copySuffix: ' - 副本'
        },
        quotaConfig: {
            backToSchemeList: '返回配额方案列表',
            title: '配额设置',
            enableControl: '启用配额控制',
            enableHint: '注意：开启配额控制后将对答卷进行配额限制，达到配额限制后将无法继续答卷',
            advancedTitle: '高级配额设置',
            stubLabel: 'STUB题目（行）：',
            headerLabel: 'HEADER题目（列）：',
            baseLabel: 'BASE筛选题目：',
            selectStubPlaceholder: '请选择STUB题目',
            selectHeaderPlaceholder: '请选择HEADER题目',
            selectBasePlaceholder: '请选择BASE题目',
            quotaTableTitle: '配额分配表格',
            currentTotal: '当前配额总数：',
            baseFilterLabel: 'BASE筛选条件：',
            selectFilterPlaceholder: '请选择筛选条件',
            total: '总计',
            option: '选项',
            quota: '配额',
            rowTotal: '行总计',
            columnTotal: '列总计',
            hintsTitle: '配额设置说明',
            hintNoLimit: '配额值为 -1 表示不限制该组合',
            hintNotAllowed: '配额值为 0 表示不允许该组合',
            hintPositive: '配额值为正数表示该组合的最大允许数量',
            hintGrandTotal: '总计会自动统计所有有效配额值（不包括-1和0）',
            hintEffectiveStage: '配额控制仅在问卷收集阶段生效',
            saveSettings: '保存配额设置',
            reset: '重置',
            currentSchemePrefix: '当前方案：',
            noSelectionTip1: '请选择左侧的配额方案进行设置',
            noSelectionTip2: '或点击上方按钮创建新的配额控制方案',
            messages: {
                loadQuotaFail: '加载配额数据失败',
                loadQuestionsFail: '加载题目列表失败',
                saveSuccess: '配额设置保存成功',
                saveFail: '保存配额设置失败'
            },
            unnamedQuestion: '未命名题目',
            unknownQuestion: '未知题目',
            quotaMode: {
                matrix: 'STUB×HEADER矩阵模式',
                single: 'STUB单维度模式',
                unconfigured: '未配置'
            },
            optionLabelDefault: '选项'
        },
        responses: "响应",
        views: "浏览",
        completion: "完成率",
        emptyTip: "暂无数据",
        emptyCreate: "创建项目",
        deleteSuccess: "删除成功",
        deleteFail: "删除失败",
        confirmDelete: "确认删除",
        confirmDeleteTip: "确定要删除项目 \"{name}\" 吗？",
        createProject: {
            createProject: "创建项目",
            selectType: '选择项目类型',
            regular: '常规问卷',
            regularDesc: '从零开始创建一个新的问卷项目',
            template: '导入模板',
            templateDesc: '从预设模板中快速创建项目',
            copy: '复制项目',
            copyDesc: '基于现有项目创建副本',
            shareCode: '从分享码复制项目',
            shareCodeDesc: '通过分享码复制一个项目',
            ai: 'AI解析',
            aiDesc: '使用AI自动生成问卷结构',
            aiBadge: '测试版',
            downloadExcelTemplate: '下载Excel文件格式模板',
            downloadJsonTemplate: '下载JSON文件格式模板',
            uploadTip: '将文件拖到此处，或',
            clickUpload: '点击上传',
            uploadNotice: '注意：请上传excel,json文件，快速创建项目',
            searchProject: '搜索项目',
            search: '搜索',
            keepLogic: '保留逻辑',
            keepScript: '保留脚本',
            createTime: '创建时间：',
            questionCount: '题目数：',
            aiPlaceholder: '请输入您想要创建的问卷内容描述，例如：创建一个关于员工满意度调查的问卷，包含工作环境、薪资待遇、职业发展等方面的问题',
            aiStart: '开始解析',
            aiClear: '清空',
            aiTip1: 'AI将根据您的描述自动生成问卷结构',
            aiTip2: '建议描述越详细，生成的问卷结构越准确',
            info: '项目信息',
            name: '项目名称',
            namePlaceholder: '请输入项目名称',
            nameRequired: '请填写项目名称',
            organization: '所属组织',
            organizationPlaceholder: '请输入所属组织',
            description: '项目描述',
            descriptionPlaceholder: '请输入项目描述',
            cancel: '取消',
            create: '创建项目',
            uploadTemplate: '请上传模板文件',
            selectCopyProject: '请选择要复制的项目',
            aiInputRequired: '请填写AI解析内容描述',
            aiParseRequired: '请先进行AI解析',
            createSuccess: '项目创建成功',
            createFail: '创建项目失败',
            createFailRetry: '创建项目失败，请稍后重试',
        },
    },
    recycle: {
        title: "回收中心",
        id: "项目ID",
        name: "项目名",
        deletedAt: "删除时间",
        createdAt: "创建时间",
        creator: "创建人",
        restore: "恢复",
        noData: "暂无数据",
        confirmDelete: "确认删除",
        confirmDeleteTip: "确定要永久删除此项目吗？此操作无法撤销。",
        restoreSuccess: "恢复成功",
        restoreFail: "恢复失败",
        deleteSuccess: "删除成功",
        deleteFail: "删除失败"
    },
    user: {
        title: "用户管理",
        pageDesc: "维护平台账号的基本资料与启用状态，账号需要具体权限时请到角色管理里分配",
        id: "用户ID",
        name: "用户姓名",
        account: "账号",
        fullname: "姓名",
        noFullname: "未填写姓名",
        mobile: "用户手机",
        email: "用户邮箱",
        avatar: "用户头像",
        avatarHint: "支持 JPG / PNG，大小不超过 2MB",
        sectionBasic: "基本信息",
        emptyList: "没有符合条件的用户，换个关键词或点重置试试",
        exportTodo: "导出功能还没有对应的后端接口，暂时不可用",
        ruleAccount: "请输入账号",
        ruleAccountLen: "账号长度需要在 2 到 32 个字符之间",
        ruleMobile: "请输入手机号",
        ruleMobileFormat: "请输入正确的 11 位手机号",
        ruleEmail: "请输入邮箱",
        ruleEmailFormat: "请输入正确的邮箱地址",
        confirmDelete: "是否确认删除用户ID为\"{id}\"的数据项？",
        addTitle: "添加用户",
        editTitle: "修改用户信息",
        uploadAvatar: "更换头像",
        uploadSuccess: "上传成功！",
        uploadFail: "上传失败: {msg}",
        uploadTypeError: "上传头像图片只能是 JPG/PNG 格式!",
        uploadSizeError: "上传头像图片大小不能超过 2MB!",
        placeholderName: "请输入用户姓名",
        placeholderFullname: "请输入真实姓名",
        placeholderMobile: "请输入用户手机",
        placeholderEmail: "请输入用户邮箱",
        placeholderAvatar: "请输入用户头像链接"
    },
    role: {
        title: "角色管理",
        pageDesc: "一个角色 = 一组菜单权限。先在这里配好菜单，再把角色分配给具体用户",
        sectionBasic: "基本信息",
        placeholderName: "请输入角色名称",
        placeholderKey: "请输入权限字符",
        keyTip: "后端接口上用来判断权限的标识，如 admin、system:user",
        sortTip: "数字越小越靠前",
        builtinTip: "内置角色，不能停用或删除",
        emptyList: "没有符合条件的角色，换个关键词或点重置试试",
        ruleName: "请输入角色名称",
        ruleNameLen: "角色名称不能超过 30 个字符",
        ruleKey: "请输入权限字符",
        ruleKeyFormat: "权限字符只能包含字母、数字、下划线和冒号",
        ruleSort: "请输入显示顺序",
        id: "角色编号",
        name: "角色名称",
        key: "权限字符",
        sort: "显示顺序",
        status: "状态",
        createTime: "创建时间",
        remark: "备注",
        menuPerm: "菜单权限",
        dataPerm: "数据权限",
        assignUser: "分配用户",
        more: "更多",
        confirmDelete: "是否确认删除角色编号为\"{id}\"的数据项？",
        addTitle: "添加角色",
        editTitle: "修改角色",
        dataScope: "权限范围",
        allData: "全部数据权限",
        customData: "自定数据权限",
        deptData: "本部门数据权限",
        deptBelowData: "本部门及以下数据权限",
        selfData: "仅本人数据权限",
        selectAll: "全选/全不选",
        parentLink: "父子联动",
        loading: "加载中，请稍候",
        remarkPlaceholder: "请输入内容",
        successAdd: "新增成功",
        successEdit: "修改成功",
        successDelete: "删除成功",
        successStatus: "{action}成功",
        confirmStatus: "确认要{action}\"{name}\"角色吗？",
        assignDataPerm: "分配数据权限",
        assignUserTitle: "分配用户",
        cancelAuth: "取消授权",
        batchCancelAuth: "批量取消授权",
        closePage: "关闭",
        selectUser: "选择用户",
        selectUserTip: "请选择要分配的用户",
        selectUserSuccess: "分配成功",
        cancelAuthSuccess: "取消授权成功",
        confirmCancelAuth: "确认要取消用户“{name}”的该角色吗？",
        confirmBatchCancelAuth: "是否取消选中用户的授权？",
        authUserSubtitle: "管理该角色下的用户，可继续添加或取消授权",
        currentRole: "当前角色",
        authUserEmpty: "该角色还没有授权用户，点击“添加用户”开始分配",
        selectUserEmpty: "没有可分配的用户，说明所有用户都已拥有该角色",
        selectUserTitleTip: "勾选后点击确定，即可把该角色授予选中的用户"
    },
    menu: {
        title: "菜单管理",
        pageDesc: "这里的每一行对应侧边栏的一个入口。目录只做分组，菜单才对应页面，按钮只用来配权限字符",
        sectionBasic: "基本信息",
        sectionRoute: "路由与组件",
        sectionPerm: "权限与状态",
        shown: "显示",
        hidden: "隐藏",
        addChild: "加子级",
        addChildTip: "在这一项下面新增一个子菜单",
        emptyFiltered: "没有匹配的菜单，换个关键词或点重置",
        filteredCount: "筛选出 {n} 项",
        hintDirectory: "只做分组，不对应具体页面",
        hintMenu: "对应一个真实页面，需要填组件路径",
        hintButton: "不出现在侧边栏，只用来配权限字符",
        confirmDeleteWithChildren: "\"{name}\"下面还有 {n} 个子菜单，删除后子菜单一并失效，确定继续吗？",
        name: "菜单名称",
        icon: "图标",
        sort: "排序",
        perms: "权限标识",
        component: "组件路径",
        status: "状态",
        createTime: "创建时间",
        confirmDelete: "是否确认删除名称为\"{name}\"的数据项？",
        addTitle: "添加菜单",
        editTitle: "修改菜单",
        successAdd: "新增成功",
        successEdit: "修改成功",
        successDelete: "删除成功",
        placeholderName: "请输入菜单名称",
        placeholderRouteName: "请输入路由名称",
        placeholderPath: "请输入路由地址",
        placeholderComponent: "请输入组件路径",
        placeholderPerms: "请输入权限标识",
        placeholderQuery: "请输入路由参数",
        placeholderIcon: "点击选择图标",
        placeholderParentMenu: "选择上级菜单",
        parentMenu: "上级菜单",
        menuType: "菜单类型",
        directory: "目录",
        menu: "菜单",
        button: "按钮",
        menuIcon: "菜单图标",
        displaySort: "显示排序",
        routeName: "路由名称",
        routeNameTip: "默认不填则和路由地址相同：如地址为：`user`，则名称为`User`（注意：为避免名字的冲突，特殊情况下请自定义，保证唯一性）",
        isExternalLink: "是否外链",
        externalLinkTip: "选择是外链则路由地址需要以`http(s)://`开头",
        routeAddress: "路由地址",
        routeAddressTip: "访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头",
        componentPath: "组件路径",
        componentPathTip: "访问的组件路径，如：`system/user/index`，默认在`views`目录下",
        permissionChar: "权限字符",
        permissionCharTip: "控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)",
        routeParams: "路由参数",
        routeParamsTip: "访问路由的默认传递参数，如：`{\"id\": 1, \"name\": \"ry\"}`",
        displayStatus: "显示状态",
        displayStatusTip: "选择隐藏则路由将不会出现在侧边栏，但仍然可以访问",
        menuStatus: "菜单状态",
        menuStatusTip: "选择停用则路由将不会出现在侧边栏，也不能被访问",
        yes: "是",
        no: "否",
        mainCategory: "主类目",
        nameRequired: "菜单名称不能为空",
        sortRequired: "菜单顺序不能为空",
        pathRequired: "路由地址不能为空"
    },
    header: {
        lang: {
            zh: '简体中文',
            zh_TW: '繁体中文',
            en: '英文',
            jp: '日文',
            ko: '韩文',
            id: '印度尼西亚文',
        },
        helpDoc: '帮助文档'
    },
    questionEdit: {
        readonlyLocked: '当前项目为仅查看权限，内容不能修改',
        // 题型名称
        sortQuestion: '排序题',
        singleQuestion: '单选题',
        multiQuestion: '多选题',
        numberQuestion: '数值题',
        textQuestion: '文本题',
        textareaQuestion: '多行文本题',
        dateQuestion: '日期题',
        timeQuestion: '时间题',
        uploadQuestion: '上传题',
        scoreQuestion: '评分题',
        scoreStyle: '评分样式',
        scoreStyleStar: '星星',
        scoreStyleNumber: '数字',
        scoreStyleEmoji: '表情',
        scoreStyleSlider: '滑块',
        scoreRange: '分值范围',
        scorePointConfig: '评分点配置',
        scorePointConfigTip: '可分别设置分值、code 和文案',
        scoreValueLabel: '分值',
        scoreCodeLabel: 'Code',
        scoreTextLabel: '文案',
        scoreTextPlaceholder: '请输入该分值的说明文案',
        titleSaveSuccess: '标题保存成功',
        ratingVeryPoor: '不满意',
        ratingNormal: '一般',
        ratingGood: '满意',
        openQuestion: '开放题',
        timestampQuestion: '时间戳',
        selectQuestion: '选择题',
        cascadeSettings: '级联设置',
        cascadeLevels: '级联层级',
        cascadeLevelLabel: '第{level}级选项',
        cascadeOptionsManagement: '级联选项管理',
        placeholderHint: '提示文本：',
        placeholderInput: '请输入第{level}级下拉框提示文本',
        manageOptions: '管理选项',
        manageSubOptions: '管理子选项',
        subOptionNamePlaceholder: '请输入子选项名称',
        optionTextLabel: '选项文本',
        optionCodeLabel: '选项编码',
        optionTextPlaceholder: '请输入选项文本',
        optionCodePlaceholder: '请输入选项编码',
        optionCodeDuplicate: '第{level}级选项中存在重复的编码，请修改',
        optionCodeDuplicateGlobal: '选项中存在重复的编码，请修改后再保存',
        optionValueDuplicate: '该题中选项值不能重复',
        publishOptionCodeDuplicate: '以下题目存在重复的选项编码，请修改后再发布：{questions}',
        matrixSingleQuestion: '矩阵单选题',
        matrixMultiQuestion: '矩阵多选题',
        matrixBlankQuestion: '矩阵填空题',
        matrixStatisticsQuestion: '矩阵统计题',
        matrixCompositionQuestion: '矩阵复合题',
        thermodynamicChartQuestion: '热力图题',
        projectLanguage: '项目语言',
        projectFile: '项目文件',
        autoRecordQuestion: '过录题',
        maxDiffQuestion: 'MaxDiff题',
        combinationQuestion : '组合题',
        thermo: {
            changeImage: '更换图片',
            showIndex: '显示编号',
            maxClicks: '最大点击次数',
            color: '颜色',
            size: '大小',
            clearPoints: '清空点击点',
            clickCount: '点击次数：{count}',
            imageOnlyTip: '仅支持图片文件'
        },
        
        // 特殊题型
        specialComponents: '特殊题型',
        loopQuestion: '循环题',

        // 通用操作
        delete: '删除',
        clear: '清空',
        addOption: '添加选项',
        batchAdd: '批量添加',
        batchAddTitle: '批量添加选项',
        batchAddHint: '一行一个选项。从 Excel 粘贴两列时，数字列自动识别为选项值；没有制表符时也支持「1 选项文本」这种空格分隔。识别结果在下方预览，可拖拽调整最终顺序。',
        batchAddPlaceholder: '1\t这是选项A\n2\t这是选项B\n3\t这是选项C',
        batchAddParsedCount: '已识别 {count} 个选项',
        batchAddPreviewTitle: '添加后的完整顺序',
        batchAddPreviewEmpty: '粘贴内容后，这里会显示添加后的完整选项列表',
        batchAddTagNew: '新增',
        batchAddDragTip: '按住整行拖拽可调整顺序，值与选项文本均可直接修改',
        batchAddValueTaken: '值 {input} 已被本题其他选项占用，已自动改为 {value}',
        batchAddValueInvalid: '值 {input} 不是有效的正整数，已自动改为 {value}',
        batchAddValueAdjustedTip: '有 {count} 个选项的值与本题已有选项重复或非法，已自动改为未占用的值；把鼠标移到该行的黄色图标可查看原因，也可直接改成你想要的值。',
        batchAddRowErrorSummary: '有 {count} 行需要修正后才能确定',
        batchAddRichHint: '该选项含富文本样式，此处仅显示纯文本；不修改则保留原有样式',
        batchAddWhitespaceHint: '该选项文本首尾含空格，会原样保留并在答卷端显示',
        batchAddModeTab: '按制表符分列',
        batchAddModeSpace: '按空格分列',
        batchAddModeTextOnly: '整行作为选项文本',
        batchAddSuccess: '已添加 {count} 个选项',
        batchAddExistingCount: '原有 {count} 项',
        batchAddRemoveExisting: '删除原有选项',
        batchAddRemoveExistingHint: '一键删掉上面所有原有选项，只留本次粘贴进来的新选项',
        batchAddRestoreRemoved: '恢复 {count} 项',
        batchAddRestoreRemovedHint: '把刚删掉的原有选项按原位置放回来',
        batchAddRemoveRowHint: '删除这一项（原有选项也可以删）',
        batchAddPreviewEmptyAfterRemove: '原有 {count} 个选项已全部移除；粘贴新选项后可继续，或点上方「恢复」找回原有选项',
        batchAddNeedOneOption: '预览区至少需要保留 1 个选项',
        batchAddSuccessMixed: '已添加 {added} 个、删除 {removed} 个选项',
        batchDelete: '批量删除',
        batchSelectAll: '全选',
        batchSelectOption: '选择该选项',
        batchSelectedCount: '已选 {count} 项',
        batchDeleteSelected: '删除所选',
        batchDeleteConfirmMessage: '确定删除所选的 {count} 个选项吗？删除后可用「撤销」恢复。',
        batchDeleteSuccess: '已删除 {count} 个选项',
        batchSelectAllRows: '全选行',
        batchSelectAllCols: '全选列',
        batchSelectRow: '选择该行',
        batchSelectColumn: '选择该列',
        batchSelectedMatrixCount: '已选 {rows} 行 · {cols} 列',
        batchDeleteConfirmMatrix: '确定删除所选的 {rows} 行、{cols} 列吗？删除后可用「撤销」恢复。',
        batchDeleteSuccessMatrix: '已删除 {rows} 行、{cols} 列',
        clearConfirmCount: '共 {count} 题',
        loadingMoreQuestions: '正在加载后面的题目…',
        loadedProgress: '已加载 {loaded}/{total} 题，点击加载更多',
        richText: '富文本',
        confirm: '确定',
        cancel: '取消',

        // 占位符
        optionPlaceholder: '请输入选项',
        numberPlaceholder: '请输入数字',
        textPlaceholder: '请输入文本',
        datePlaceholder: '请选择日期',
        timePlaceholder: '请选择时间',
        scorePlaceholder: '请评分',
        uploadPlaceholder: '点击上传或将文件拖到此处',
        dateFormat: '时间日期格式',
        searchPlaceholder: '搜索题目（标题/题号）',
        quickJump: '快速跳转',
        searchAndJump: '搜索题目后选中跳转',
        refreshOutline: '刷新大纲',
        order: '顺序',
        orderImportExport: '题号顺序导入导出',

        // 收藏功能
        collectQuestion: '收藏题目',
        collectSuccess: '题目收藏成功',
        collectFail: '收藏失败',

        // 提示消息
        saveSuccess: '保存成功',
        saveFail: '保存失败',
        deleteSuccess: '删除成功',
        deleteFail: '删除失败',
        uploadSuccess: '上传成功',
        uploadFail: '上传失败',
        emptyOptionError: '选项内容不能为空',
        optionValueEmpty: '选项值不能为空或 0',
        optionEmptyReverted: '选项内容为空，已恢复原内容；如需删除请点右侧删除按钮',
        addQuestionSuccess: '添加题目成功',
        undo: '撤销',
        undoSuccess: '已撤销上一步',
        undoNoChange: '没有可撤销的改动',
        undoFailed: '撤销失败，请重试',
        switchLanguageSuccess: '切换语言成功',
        maxFilesExceeded: '最多只能上传 {max} 个文件',
        fileSizeExceeded: '文件大小不能超过 {size}MB',

        // 编辑相关
        newOption: '新选项',
        editTitle: '编辑标题',
        editOption: '编辑选项',
        deleteConfirm: '确定要删除吗？',
        titleMarkupLostTitle: '标题包含格式',
        titleMarkupLostMessage: '该标题包含富文本格式，直接保存纯文本会丢失格式。确定继续吗？（也可点击「富文本」保留格式编辑）',

        // 引用答案（把前面题目的作答插入题干）
        answerRef: {
            button: '引用答案',
            buttonTip: '把前面题目的作答插入到题干里',
            title: '引用前面题目的答案',
            subtitle: '把前面题目的作答插入到题干中，答题时会自动替换成受访者选择的内容',
            search: '搜索题号或题干…',
            empty: '前面没有可引用的题目',
            loading: '正在加载题目…',
            disabled: '暂不支持',
            disabledTip: '该题型暂不支持引用答案',
            quickInsert: '插入',
            modes: '引用方式',
            modeWhole: '整题答案',
            modeWholeDesc: '引用用户在这道题上的完整作答',
            modeOther: '「其他」填写内容',
            modeOtherDesc: '只引用用户在“其他”里输入的文字',
            modeItem: '第 {n} 个被选项',
            modeRow: '第 {n} 行',
            modeCell: '第 {r} 行第 {c} 列',
            modeItemTitle: '第 N 个被选项',
            modeItemDesc: '引用多选题/排序题里用户选的第 N 项',
            modeRowTitle: '某一行',
            modeRowDesc: '引用矩阵题这一行的作答',
            modeCellTitle: '某个单元格',
            modeCellDesc: '引用矩阵题这个单元格的作答',
            rowPick: '选择要引用的行',
            cellPick: '点击表格选择单元格',
            otherPick: '选择哪个“其他”',
            itemPick: '选择第几项',
            preview: '示例',
            previewPrefix: '预览：',
            unanswered: '未作答时显示：{text}',
            unansweredSample: '[未答题]',
            insert: '插入到题干',
            cancel: '取消',
            inserted: '已引用',
            dragHint: '直接拖动题干里的胶囊调整位置',
            broken: '引用已失效',
            removeRef: '删除这个引用',
            brokenTip: '这道题已删除或题号已变更',
            noPreview: '选择左侧题目，查看可引用的内容'
        },

        // 快捷键说明
        shortcutsEntry: '快捷键',
        shortcutsTitle: '编辑快捷键',
        shortcutsTip: '题干、选项、矩阵行列都支持单击原地编辑，下面的快捷键在原地编辑时生效。',
        shortcutsGroupTitle: '题干',
        shortcutsGroupOption: '选项（单选 / 多选 / 排序）',
        shortcutsGroupMatrix: '矩阵行列（五种矩阵题）',
        shortcutsGroupBatch: '批量删除模式',
        shortcutClick: '单击',
        shortcutTitleClick: '进入题干原地编辑',
        shortcutTitleEnter: '保存题干并退出编辑',
        shortcutTitleEsc: '放弃本次修改',
        shortcutTitleRich: '需要加粗、插图等格式时点标题右侧的「富文本」',
        shortcutOptionClick: '进入选项原地编辑',
        shortcutOptionEnter: '保存并跳到下一个选项',
        shortcutOptionShiftEnter: '保存并在下面新建一个选项',
        shortcutOptionEsc: '放弃本次修改',
        shortcutUndo: '撤销上一步（改题干、改选项、删选项、拖排序、批量增删都能撤，最多 20 步）',
        shortcutMatrixClick: '进入行标题 / 列标题原地编辑',
        shortcutMatrixEnter: '保存并跳到下一行 / 下一列',
        shortcutMatrixShiftEnter: '保存并新增一行 / 一列',
        shortcutMatrixEsc: '放弃本次修改',
        shortcutMatrixUndo: '撤销上一步行列改动',
        shortcutBatchEnter: '选中 / 取消选中当前选项',
        shortcutBatchEsc: '退出批量删除模式',

        // 下一题倒计时
        //nextWaitSeconds: '下一题倒计时(秒)',
        //nextWaitSecondsTip: '0 表示不启用；点击“下一题”后开始计时',
        nextWaitSecondsSaveTip: '设置了下一题倒计时后请点击保存配置',

        // 默认值
        defaultTitle: '新题目',
        defaultOption: '选项{index}',
        
        // 输入框占位符
        inputQuestionNo: '请输入题号',
        
        // 脚本相关
        scriptType: '脚本类型',
        tags: '标签',
        
        //父组件
        // ===== 以下为design父组件template新增key，重复的也保留，后续可微调 =====
        edit: '编辑',
        save: '保存配置',
        statistics: '统计',
        data: '数据',
        download: '下载',
        publish: '发布',
        quotaLink: '配额链接',
        quotaLinkMissingConfig: '未配置外部配额系统地址',
        quotaLinkMissingSurveyId: '问卷ID不存在',
        projectFile: '项目文件',
        projectFileView: {
            exportTitle: '导出项目',
            importTitle: '导入项目',
            exportJson: '导出JSON',
            exportExcel: '导出EXCEL',
            preview: '预览',
            hidePreview: '隐藏预览',
            questionNo: '题号',
            questionText: '题干',
            questionType: '题型',
            manualImport: '手动导入',
            fileLabel: '文件：',
            questionCountLabel: '题目数：{count}',
            dropTitle: '拖拽JSON或Excel文件到此处',
            dropSubtitle: '或点击该区域/"手动导入"按钮选择文件',
            dropTip: '支持 .json、.xlsx、.xls 文件',
            selectAllLabel: '全选 ({selected}/{total})',
            confirmImport: '确认导入',
            importing: '导入中...',
            clear: '清空',
            close: '关闭',
            exportSuccess: '导出成功',
            exportFail: '导出失败',
            projectIdRequired: '项目ID不存在',
            noPreviewQuestions: '没有可预览的题目',
            importSuccess: '导入完成',
            importFail: '导入失败',
            noQuestionsSelected: '未选择题目',
            importNoQuestionsParsed: '未解析到题目，请检查Excel模板内容',
            excelParseFailWithMsg: 'Excel文件解析失败：{msg}',
            duplicateQuestionNos: 'Excel校验失败：存在重复题号。重复项：{details}',
            unsupportedFileType: '不支持的文件格式，请选择JSON或Excel文件',
            fileNoQuestionsData: '文件中未找到题目数据',
            jsonParseFail: '解析失败：JSON文件格式不正确'
        },
        projectLanguage: '项目语言',
        importQuestions: '导入题目',
        exportGuid: '导出GUID',
        exportGuidLoading: '正在导出GUID，数据量较大，请耐心等待...',
        exportGuidSuccess: '导出GUID成功',
        exportGuidFail: '导出GUID失败：{msg}',
        questionType: '题型',
        outline: '大纲',
        aiTools: 'AI工具',
        previewDialog: {
            title: '题目预览',
            projectId: '项目ID：',
            questionNo: '题号：',
            refresh: '刷新预览',
            loading: '加载中...',
            empty: '暂无预览数据',
            projectOrQuestionIdMissing: '缺少项目或题目ID参数',
            notHtml: '接口未返回HTML内容',
            fetchFail: '获取预览失败',
            fetchFailRetry: '获取预览失败，请稍后重试',
            devicePhone: '手机',
            deviceTablet: '平板',
            devicePc: '电脑'
        },
        questionBank: {
            name: '题库',
            searchPlaceholder: '搜索题目',
            myBank: '我的题库',
            publicBank: '公共题库',
            add: '添加',
            type: '题型',
            category: '分类',
            title: '标题',
            options: '选项',
            unnamedOption: '未命名选项',
            noOptions: '无选项',
            close: '关闭',
            addToForm: '添加到问卷中',
            collect: '收藏',
            addedToFormSuccess: '题目已添加到问卷',
            addFail: '添加失败',
            collectSuccess: '收藏成功',
            collectFail: '收藏失败',
        },
        basicComponents: '基础组件',
        advancedComponents: '进阶组件',
        myQuestionBank: '我的题库',
        add: '添加',
        comprehensiveCustomerSatisfactionSurvey: '综合客户满意度调查',
        publicQuestionBank: '公共题库',
        standardQuestionBankGroup: '标准题库组',
        standardTextQuestion: '标准文本题',
        standardSingleChoiceQuestion: '标准单选题',
        standardMultipleChoiceQuestion: '标准多选题',
        standardOpenQuestion: '标准开放题',
        standardRatingQuestion: '标准评分题',
        specialQuestionBankGroup: '特殊题库组',
        specialTextQuestion: '特殊文本题',
        otherQuestionBankGroup: '其他题库组',
        set: '设置',
        thenExecutionActions: 'THEN执行动作',
        beforeExecution: '执行前',
        duringExecution: '执行中',
        afterExecution: '执行后',
        favoriteScript: '收藏脚本',
        personal: '个人',
        details: '详情',
        
        tabSetting: '设置',
        tabLogic: '逻辑',
        tabScript: '脚本',
        options: '选项',
        // 倒计时设置
        nextWaitSeconds: '下一题倒计时(秒)',
        nextWaitSecondsTip: '0 或空表示不启用',
        moreConfig: '更多配置',
        lengthPx: '长度 (px)：',
        widthPercent: '宽度 (%)：',
        minLength: '最小字数：',
        maxLength: '最大字数：',
        minNumber: '最小数值：',
        maxNumber: '最大数值：',
        allowChar: '字符：',
    allowNumber: '数值：',
    allowDecimal: '小数：',
    decimalPlaces: '小数位：',
        fontSelect: '字体选择',
        fontSize: '字体大小',
        optionSize: '选项大小',
        layoutDirection: '布局方向',
        horizontal: '横向',
        vertical: '纵向',
        rowCount: '行数',
        rowWidth: '行宽',
        colCount: '列数',
        colHeight: '列高',
        hideImage: '隐藏图片',
        operate: '操作',
        saveLogic: '保存逻辑',
        logicList: '逻辑列表',
        selectCondition: '选择条件',
        selectOption: '选择选项',
        inputValue: '请输入值',
        selectRelation: '选择关系',
        priority: '优先级',
        selectAction: '选择动作',
        inputText: '请填写文本',
        inputLink: '请输入跳转链接',
        inputQuestionTitle: '请输入新题干',
        selectRowCol: '选择行/列',
        selectValue: '选择值',
        row: '行',
        column: '列',
        selectRowOption: '选择行选项',
        selectColOption: '选择列选项',
        conditions: {
            true: '恒真',
            equal: '等于',
            notEqual: '不等于',
            contain: '包含',
            NContain: '不包含',
            isBlank: '为空',
            isNBlank: '不为空',
            countLT: '统计选项少于',
            countGT: '统计选项多于',
            countEQ: '统计选项等于',
            countNE: '统计选项不等于',
            countGE: '统计选项大于等于',
            countLE: '统计选项小于等于',
            countVLT: '统计值小于',
            countVGT: '统计值大于',
            countVEQ: '统计值等于',
            countVGE: '统计值大于等于',
            countVLE: '统计值小于等于'
        },
        actions: {
            thisValues: '选项赋值',
            thisShowOptions: '显示选项',
            thisRandom: '打乱选项',
            thisHide: '隐藏选项',
            thisMatchShow: '展示匹配选项',
            thisDifferentShow: '展示不匹配选项',
            thisSingle: '此题单选',
            thisAutoRecord: '自动记录题目选项',
            thisAutoRecVal: '自动记录值',
            thisFixShow: '匹配值选项',
            thisRandom_v2: '打乱行/列',
            thisHide_v2: '隐藏行/列',
            goto: '跳转',
            gotoLink: '访问链接',
            gotoNQ: '跳转未答题',
            goBack: '返回上题',
            close: '结束问卷',
            screenClose: '逻辑甄别',
            alert: '弹窗',
            confirm: '弹出确认弹窗',
            skipThis: '跳过此题',
            notSkip: '不能跳过此题',
            canBlank: '可以为空',
            otherBlank: '其他题可以为空',
            lock: '锁题',
            unlock: '不锁题',
            setQuestionTitle: '修改题干'
        },
        connectors: {
            ifPrefix: '如果 ',
            thenPrefix: '则 ',
            andConnector: ' 并且 '
        },
        logic: {
            and: '并且',
            or: '或者',
            end: '结束'
        },
        searchScript: '搜索脚本',
        detail: '详情',
        scriptEdit: '脚本编辑',
        scriptDetail: '脚本详情',
        search: '搜索',
        questionNo: '题号',
        logicSettings: '设置',
        refreshLogic: '刷新',
        addLogic: '添加逻辑',
        ifConditionSettings: 'IF条件设置',
        favoriteScriptList: '脚本收藏列表',
        public: '公共',
        apply: '应用',
        saveScript: '保存脚本',
        optionContent: '选项内容',
        tabMoreSetting: '设置',
        tabMoreDisplay: '显示',
        tabMoreImage: '图片',
        saveSuccess: '保存成功',
        saveFailed: '保存失败',
        fontMicrosoftYaHei: '微软雅黑',
        fontSimSun: '宋体',
        fontSimHei: '黑体',
        fontArial: 'Arial',
        ai: {
            codingButton: 'AI开放题编码',
            tableButton: 'AI表格生成',
            reportTitle: 'AI 调研报告',
            notOpen: '暂未开放'
        },
        addOther: '添加其他',
        addNoneOfAbove: '添加以上皆无选项',
        noneOfAbove: '以上皆无',
        exclusiveTag: '此题单选',
        exclusiveTagTip: '此题单选：选中后自动取消其他选项',
        exclusiveRemoveTip: '点击可删除逻辑',
        exclusiveExists: '已存在此题单选逻辑',
        exclusiveRemoveConfirm: '删除后会移除这条「此题单选」逻辑，确定吗？',
        exclusiveRemoved: '已删除此题单选逻辑',
        exclusiveAdded: '已添加此题单选逻辑',
        exclusiveLogicSaveFailed: '此题单选逻辑保存失败，请到「逻辑」页手动添加',
        netGroup: 'NET分组',
        netGroupPlaceholder: '请输入分组名',
        netLabel: '分组：',
        netNone: '-',
        otherOptionLabel: '其他选项：',
        otherInputPlaceholder: '请输入其他内容',
        actionNotAllowedSameQuestion: '选项赋值无法作用于与IF条件相同的题目',
        actionThisSingleRequiresMultiple: '“此题单选”仅适用于多选题，请先选择多选题',
        // 设计页新增国际化
        totalQuestions: '共 {count} 道题目',
        clearAll: '清空所有',
        clearAllTitle: '清空所有题目',
        collapse: '折叠',
        expand: '展开',
        unnamedQuestion: '（未命名题目）',
        clearConfirmTitle: '确认清空',
        clearConfirmMessage: '确定要清空所有题目吗？此操作不可恢复。',
        clearedMessage: '已清空所有题目',
        clearPartialFailed: '部分题目删除失败，请刷新页面查看最新状态',
        clearFailedMessage: '清空失败: {msg}',
        valueLabel: '值：',
        otherLabel: '其他：',
        other: '其他',
        isOther: '是否其他',
        deleteConfirmTitle: '删除确认',
        deleteConfirmMessageOption: '确认删除该选项？Label: {label}, Code: {code}',
        optionDeleted: '选项已删除',
        deleteConfirmMessageQuestion: '确认删除该题目？题号：{no}, 标题：{title}',
        questionDeleted: '题目已删除',
        maxdiff: {
            mostImportant: '最重要',
            leastImportant: '最不重要',
            mostLabel: '最重要标签',
            leastLabel: '最不重要标签',
            instruction: '请选择最重要和最不重要的属性',
            instructionLabel: '说明文本',
            instructionHint: '展示在任务预览的标题处',
            alignment: '对齐方式',
            alignCenter: '居中',
            alignLeft: '左对齐',
            attributesPerTask: '每任务属性数',
            attributesPerTaskHint: '范围 3–{max}，且不超过属性数（当前 {count}）',
            totalTasks: '任务总数',
            totalTasksHint: '最多可生成 {max} 个任务',
            taskPreview: '任务预览',
            prev: '上一个',
            next: '下一个'
        },
        matrix: {
            functionA: '功能A',
            functionB: '功能B',
            functionC: '功能C',
            projectA: '项目A',
            projectB: '项目B',
            projectC: '项目C',
            satisfied: '满意',
            average: '一般',
            dissatisfied: '不满意',
            evaluate: '评价',
            suggestion: '建议',
            remark: '备注',
            enterEvaluate: '请输入评价',
            enterSuggestion: '请输入建议',
            enterRemark: '请输入备注',
            firstQuarter: '第一季度',
            secondQuarter: '第二季度',
            thirdQuarter: '第三季度',
            fourthQuarter: '第四季度',
            enterValue: '请输入数值',
            score: '评分',
            select: '选择',
            exportOrientation: '主方向',
            perRow: '行',
            perCol: '列',
            exclusiveLabel: '以上皆无',
            exclusiveNone: '关闭',
            exclusiveRow: '仅行',
            exclusiveCol: '仅列',
            exclusiveBoth: '行+列',
            transposeStructure: '题目结构转置',
            total: '合计'
        },
        matrixComposition: {
            // 按钮文本
            addColumn: '添加列',
            addRow: '添加行',
            swapRowsAndColumns: '行列转置',
            deleteRow: '删除',
            // 弹窗标题
            editRow: '编辑行',
            addRowDialog: '添加行',
            editColumn: '编辑列',
            addColumnDialog: '添加列',
            // 表单标签
            rowText: '行文本',
            columnText: '列文本',
            columnCode: '列编码',
            columnType: '列类型',
            required: '是否必填',
            requiredWhen: '条件必填',
            optionSettings: '选项设置',
            // 列类型选项
            radio: '单选',
            checkbox: '多选',
            input: '文本输入',
            select: '下拉选择',
            // 条件必填相关
            dependencyLogic: '依赖逻辑',
            dependencyColumns: '依赖列',
            anyColumnHasValue: '任一列有值',
            allColumnsHaveValue: '所有列有值',
            // 提示信息
            requiredWhenHint: '当依赖列满足条件时，此列才必填',
            requiredHint: '注意：当题目中没有多选列时，此设置无效，将按"每行至少填一项"校验',
            finalCode: '最终编码',
            // 后缀相关
            suffixPlaceholder: '请输入单位',
            suffixDisplay: '请输入单位',
            // 操作成功提示
            rowSwapSuccess: '行交换成功',
            columnSwapSuccess: '列交换成功',
            rowColumnSwapSuccess: '行列对换成功',
            columnRowSwapSuccess: '列行对换成功',
            transposeSuccess: '行列转置成功',
            // 确认对话框
            confirmSwap: '确定要将此行与目标列进行对换吗？',
            confirmColumnToRow: '确定要将此列与目标行进行对换吗？',
            confirmTranspose: '确定要进行行列转置吗？此操作将交换所有行和列的位置。',
            // 验证消息
            enterRowText: '请输入行文本',
            enterColumnText: '请输入列文本',
            enterColumnCode: '请输入列编号',
            columnCodeExists: '列编号已存在，请使用其他编号',
            selectAtLeastOneOption: '下拉列至少需要一个选项',
            // 必填标记
            requiredMark: '必填',
            // 条件必填提示
            conditionalRequired: '条件必填',
            conditionalRequiredText: '当{logic}列【{columns}】有值时必填',
            anyLogic: '任一',
            allLogic: '所有'
        },
        Statistics: {
            version: '版本',
            versionPlaceholder: '请输入数字版本号',
            versionTooltip: '只能输入纯数字，如：1、2、3',
            linkType: '链接类型',
            linkTypeAll: '全部',
            linkTypeTest: '测试链接',
            linkTypeProd1: '正式链接1',
            linkTypeProd2: '正式链接2',
            linkTypeOffline: '离线版本',
            linkTypeCustom: '自定义',
            dateRange: '时间范围',
            filter: '筛选',
            dashboardTitle: '数据分析仪表板',
            effectiveCount: '有效回收量',
            totalCount: '总调查量',
            recoveryRate: '回收率',
            avgTime: '平均完成时间',
            deviceModel: '设备型号',
            dailyTrend: '天收集趋势',
            respondentLocation: '受访者属地分布',
            briefRecordList: '简要记录列表',
            projectId: '项目ID',
            ipAddress: 'IP地址',
            deviceType: '设备型号',
            time: '时间',
            duration: '用时',
            singleChoiceTitle: '单选题答案分布',
            singleChoiceOption: '选项分布',
            multipleChoiceTitle: '多选题答案分布',
            multipleChoicePeople: '选择人数',
            optionA: '选项A',
            optionB: '选项B',
            optionC: '选项C',
            optionD: '选项D',
            china: '中国',
            usa: '美国',
            europe: '欧洲',
            asiaOther: '亚洲其他',
            other: '其他',
            ios: 'iOS',
            android: 'Android',
            pc: '电脑',
            windows: 'Windows',
            mac: 'Mac',
        },
        dataView: {
            listTitle: '答题记录',
            id: 'ID',
            projectId: '项目ID',
            version: '版本',
            linkType: '链接类型',
            status: '状态',
            statusMap: {
                filter: '被筛选',
                active: '进行中',
                out: '配额满',
                done: '已完成',
            },
            startTime: '答题开始时间',
            endTime: '答题结束时间',
            updateTime: '记录修改时间',
            duration: '答题用时',
            ipAddress: 'IP地址',
            deviceType: '设备型号',
            device: '具体设备',
            actions: '操作',
            edit: '编辑',
            details: '详情',
            editAnswer: '编辑答案',
            cancel: '取消',
            save: '保存',
            refresh: '刷新数据',
            pageTotal: '共 {total} 条记录',
            loading: '正在加载数据...',
            noRecords: '暂无答题记录',
            audioList: '音频列表',
            notify: {
                filterApplied: '筛选条件已应用',
                filterReset: '筛选条件已重置',
                questionFilterApplied: '题目筛选条件已应用',
                questionFilterReset: '题目筛选条件已重置',
                noRecordsMatched: '暂无符合条件的答题记录',
                loadSuccess: '成功加载 {count} 条记录',
                fetchFail: '获取答题记录失败，请检查网络连接',
                networkRetryText: '网络连接失败，是否重试？',
                retry: '重试'
            }
        },
        downloadView: {
            title: '数据下载',
            subtitle: '选择文件格式与下载格式',
            exportOptions: '导出选项',
            exportOptionsSubtitle: '选择导出格式和选项',
            fileFormat: '文件格式',
            exportOptionsTitle: '导出选项',
            dateRange: '时间范围',
            startDatePlaceholder: '开始日期',
            endDatePlaceholder: '结束日期',
            startExport: '开始导出',
            excel: 'Excel',
            excelDesc: '适用于数据分析和处理',
            csv: 'CSV',
            csvDesc: '通用格式，支持所有设备',
            pdf: 'PDF',
            pdfDesc: '适合打印和分享',
            json: 'JSON',
            jsonDesc: '适用于开发者和系统集成',
            spss: 'SPSS',
            spssDesc: '适用于统计分析软件',
            includeAnswerTime: '包含答题时间',
            includeDeviceInfo: '包含设备信息',
            includeIpAddress: '包含IP地址',
            includeLocation: '包含地理位置(待完善)',
            includeUserId: '包含用户标识',
            includeAnswerType: '包含答案类型',
            includeQuestionAnswers: '包含问卷答案',
            exportImageAnswer: '导出图片答案(待完善)',
            // DownloadView page filters
            surveyStatus: '问卷状态',
            statusAll: '全部',
            statusAnswered: '完成',
            compositeSplit: '复合题拆分',
            dataMode: '数据形式',
            code: 'Code',
            label: 'Label',
            comingSoon: '功能待开发，敬请期待',
            exportFail: '导出失败',
            spssExportTypeError: 'SPSS 导出失败（返回类型异常）',
            spssExportEmptyFile: 'SPSS 导出失败（文件为空）',
            spssExportFail: 'SPSS 导出失败',
            audio: '音频',
            audioDesc: '批量下载所有录音文件',
            image: '图片',
            imageDesc: '批量下载所有上传题文件',
            language: '语言',
            languageDefault: '默认(不传)',
        },
        publishProject: {
            title: '发布项目',
            historyLink: '历史链接',
            generateLink: '生成链接',
            moreLinks: '更多链接',
            downloadLink: '下载链接',
            format: '格式',
            linkGenerator: '问卷链接生成器',
            fixedLink: '固定链接生成',
            prod1: '正式链接1',
            prod1Tip: '带 guid 和 ip控制',
            prod2: '正式链接2',
            prod2Tip: '问卷编号开启',
            test: '测试链接',
            testTip: '带导航栏，显示上一题按钮',
            ipCtrlDeveloping: 'IP 控制功能还在开发中',
            breakpointAutoCheckedTip: '勾选{source}后，答题断点控制会自动勾选',
            breakpointControlledTip: '答题断点控制不能单独勾选，请通过 guid 控制或问卷编号开启来联动',
            offline: '离线链接',
            offlineTip: '离线链接',
            custom: '自定义链接',
            customTip: '自定义链接',
            customLink: '定制链接生成',
            accessControl: '访问控制',
            ipCtrl: 'IP控制',
            guidCtrl: 'GUID控制',
            surveyIdCtrl: '问卷编号开启',
            collaborationCtrl: '协作模式',
            breakpointCtrl: '答题断点控制',
            externalIdCtrl: '外部标识断点',
            questionnaireIdMode: '问卷编号模式',
            questionnaireIdModeDigits: '纯数字',
            questionnaireIdModeSymbolPlusDigits: '字母+数字',
            questionnaireIdLength: '数字长度',
            displayOptions: '显示选项',
            showNav: '显示导航栏',
            showPrev: '显示上一题按钮',
            offlineSubmit: '线下链接报别重答',
            record: '录音开启',
            fixedOption: '固定链接',
            clearOldData: '清除旧数据',
            createLink: '创建链接',
            generatedLink: '生成的链接',
            placeholder: '请先点击创建链接',
            copy: '复制',
            open: '打开',
            copySuccess: '链接已复制到剪贴板',
            generateSuccess: '链接生成成功！',
            generateFail: '生成失败',
            downloadPlaceholder: '点击生成下载链接',
            externalDownloadTitle: '外部下载链接',
            externalDownloadPlaceholder: '外部下载链接',
            surveyStatus: '问卷状态',
            answered: '已答',
            downloadDataMode: '数据形式',
            label: '标签',
            code: '编码',
            compositeSplit: '复合题拆分',
            language: '语言',
            languageDefault: '默认(不传)',
            toggleOn: '开启',
            history: '历史链接',
            all: '全部',
            prod: '正式',
            testCategory: '测试',
            id: '编号',
            link: '链接',
            category: '分类',
            type: '类型',
            createTime: '创建时间',
            disabled: '是否禁用',
            yes: '是',
            no: '否',
            version: '版本',
            tags: '标签',
            // 完成状态发布拦截
            finishBlockedTitle: '无法发布',
            finishBlockedMessage: '问卷已结束，请调整问卷状态后再发布',
            finishBlockedButton: '知道了',
            clearConfirmTitle: '清除数据确认',
            clearConfirmMessage: '发布前将清除历史答题数据，是否确认继续？',
            clearConfirmOk: '继续',
            clearConfirmCancel: '取消清除',
            theme: '主题',
            themeDefault: '默认',
            themeLuxury: '奢侈品',
            quotaOptions: '配额选项',
            quotaAll: '全部配额',
            quotaHidden: '隐藏配额',
            quotaType: '选择panel',
            quotaHiddenRatio: '隐藏比例',
            quotaHiddenRatioPlaceholder: '请输入隐藏比例',
            quotaHiddenRatioInvalid: '隐藏比例只能输入数字，且必须大于1小于100',
            panelAll: '全部',
            confirmQuotaParams: '确认参数',
            quotaPanelRequired: '请选择panel',
            quotaModeRequired: '请选择配额模式',
            quotaNeedConfirm: '请先点击确认参数生成外部链接',
            quotaModeEmpty: '配额参数生成失败，请重试',
            quotaConfirmSuccess: '配额参数确认成功',
            quotaConfirmFail: '配额参数确认失败',
            externalQuotaTitle: '外部配额链接',
            externalQuotaPlaceholder: '请选择配额参数'
        },
        resourceManagement: {
            resourceManagement: '资源管理',
            title: '资源管理',
            upload: '上传资源',
            searchPlaceholder: '搜索资源',
            id: 'ID',
            name: '资源名称',
            projectId: '项目ID',
            createTime: '创建时间',
            url: '资源链接',
            actions: '操作',
            copyLink: '复制链接',
            delete: '删除',
            confirmDelete: '确认删除该资源吗？',
            confirm: '提示',
            deleteSuccess: '删除成功',
            deleteFail: '删除失败',
            copySuccess: '链接已复制到剪贴板',
            fetchFail: '获取资源列表失败',
            pageTotal: '共 {total} 条',
        },
        resourceUpload: {
            title: '上传资源',
            name: '资源名称',
            namePlaceholder: '请输入资源名称',
            file: '资源附件',
            uploadText: '将文件拖到此处，或',
            clickUpload: '点击上传',
            uploadTip: '注意：大小限制在100MB（支持 jpg、png、pdf、doc、docx、xls、xlsx 格式）',
            cancel: '取 消',
            confirm: '确 定',
            fileTypeError: '文件格式不支持',
            fileSizeError: '文件大小不能超过100MB',
            nameRequired: '请输入资源名称',
            fileRequired: '请选择上传文件',
            uploadSuccess: '上传成功',
            uploadFail: '上传失败',
            deleteFail: '删除资源失败，请重试',
        },
        autoRecord: {
            notFoundSourceOptions: '未找到源题选项，无法生成映射',
            addedMappings: '已新增 {count} 条映射',
            copySuccess: '映射JSON已复制到剪贴板',
            exportFail: '导出失败',
            importTitle: '导入映射',
            importConfirm: '导入',
            importPlaceholder: '粘贴映射JSON数组或CSV（key,value）',
            importInputPlaceholder: '[{"key":"A","value":"北京"}] 或\nA,北京',
            importSuccess: '成功导入 {count} 条（去重后 {merged} 条）',
            importFormatError: '导入失败：格式错误',
            missingQuestionId: '缺少题目ID，无法保存',
            needOneSource: '请至少选择一个源题',
            selfReferenceError: '源题不能选择当前题号，避免自引用',
            circularDependencyError: '检测到跨题循环依赖：源题链路回到当前题号，已阻止保存',
            duplicateKey: '映射存在重复键：{key}',
            formulaRequired: '启用计算时，必须填写计算公式'
        },
        projectLanguageView: {
            title: '项目语言管理',
            projectId: '项目ID: {id}',
            exportBtn: '导出语言文件',
            exportDesc: '导出当前问卷的语言模板文件(Excel格式)',
            uploadBtn: '上传语言文件',
            uploadDesc: '上传语言文件更新问卷翻译',
            close: '关闭',
            projectIdRequired: '项目ID不能为空',
            exportSuccess: '语言文件导出成功',
            exportFail: '导出失败：{msg}',
            uploadTypeError: '只能上传Excel文件!',
            uploadSizeError: '文件大小不能超过10MB!',
            uploadSuccess: '语言文件导入成功!',
            uploadFail: '导入失败，请重试'
        },
        thirdPartyConfigView: {
            title: '项目面板配置',
            enableLabel: '是否开启',
            open: '开启',
            close: '关闭',
            addPanel: '新增面板',
            loading: '正在加载面板列表...',
            empty: '暂无面板配置',
            emptyHint: '点击右上角按钮添加第一个面板'
        },
        thirdPartyConfig: {
            typeSelection: {
                title: '选择配置类型',
                defaultTitle: '自定义第三方配置',
                defaultDesc: '配置第三方链接和回调参数',
                emailTitle: '第三方邮件推送',
                emailDesc: '配置邮件发送和受访者管理',
                confirm: '确认选择',
                back: '返回选择配置类型'
            },
            steps: {
                emailConfig: '邮箱配置',
                uploadRespondents: '上传受访者',
                thirdpartyConfig: '第三方配置'
            },
            data: {
                title: '数据管理',
                downloadTemplate: '下载模板',
                uploadData: '上传数据',
                uploading: '上传中...',
                clearData: '清空数据',
                searchPlaceholder: '请输入邮箱地址搜索',
                table: {
                    guid: 'GUID',
                    email: '邮箱',
                    subject: '邮件主题',
                    content: '邮件内容',
                    country: '国家',
                    firstTime: '首次时间',
                    lastTime: '最后时间',
                    total: '总数',
                    status: '状态',
                    statusDesc: '状态描述'
                }
            },
            email: {
                title: '邮箱配置',
                panelName: '面板名称',
                panelNamePlaceholder: '请输入面板名称',
                emailAddress: '邮箱地址',
                emailPlaceholder: 'admin@example.com',
                smtpServer: 'SMTP服务器',
                smtpPlaceholder: 'smtp.qq.com',
                password: '密码/授权码',
                passwordPlaceholder: '••••',
                port: '端口号',
                save: '保存邮箱配置'
            },
            thirdparty: {
                title: '第三方配置',
                panelName: '面板名称',
                panelNamePlaceholder: '请输入面板名称',
                links: '链接',
                linksPlaceholder: 'survey.test1.com;survey.test2.com',
                callback: '回传',
                mappingTitle: '参数映射关系',
                addMapping: '添加映射',
                paramKeyPlaceholder: '参数名(如:a)',
                paramValuePlaceholder: '映射值(如:uid)',
                emptyMapping: '暂无映射关系，点击上方按钮添加',
                status: '状态',
                statusPlaceholder: 's',
                complete: '完成',
                completeUrlPlaceholder: 'survey.test.com/survey/survey/back.do?status=1',
                screen: '筛选',
                screenUrlPlaceholder: 'survey.test.com/survey/survey/back.do?status=2',
                quota: '配额',
                quotaUrlPlaceholder: 'survey.test.com/survey/survey/back.do?status=3',
                flexible: '灵活跳转',
                flexibleTip: '开启后按链接携带的 return 跳转，三个回调地址将隐藏',
                save: '保存第三方配置'
            },
            validation: {
                email: {
                    nameRequired: '请输入面板名称',
                    nameLength: '长度在 1 到 50 个字符',
                    emailRequired: '请输入邮箱地址',
                    emailInvalid: '请输入正确的邮箱地址',
                    smtpRequired: '请输入SMTP服务器地址',
                    passwordRequired: '请输入密码或授权码',
                    portRequired: '请输入端口号',
                    portRange: '端口号范围为 1-65535'
                },
                thirdparty: {
                    nameRequired: '请输入面板名称',
                    linksRequired: '请输入链接地址',
                    mappingRequired: '请至少添加一个参数映射',
                    mappingIncomplete: '请完善所有映射关系的参数名和映射值',
                    statusRequired: '请输入状态标识',
                    completeUrlRequired: '请输入完成回调地址',
                    screenUrlRequired: '请输入筛选回调地址',
                    quotaUrlRequired: '请输入配额回调地址'
                }
            },
            notify: {
                fetchPanelListFail: '获取面板列表失败',
                panelOpened: '面板已开启',
                panelClosed: '面板已关闭',
                updatePanelStatusFail: '更新面板开启状态失败',
                getPanelDetailFail: '获取面板详情失败',
                deletePanelSuccess: '删除成功',
                deletePanelFail: '删除失败',
                emailUpdateSuccess: '邮箱配置更新成功',
                emailCreateSuccess: '邮箱配置创建成功',
                emailSaveFail: '保存邮箱配置失败',
                thirdpartyUpdateSuccess: '第三方配置更新成功',
                thirdpartyCreateSuccess: '第三方配置创建成功',
                thirdpartySaveFail: '保存第三方配置失败',
                allUpdateSuccess: '配置更新成功',
                allCreateSuccess: '配置创建成功',
                allSaveFail: '保存配置失败',
                completeAllSteps: '配置完成！所有步骤已完成。',
                templateDownloadSuccess: '模板下载成功',
                templateDownloadFail: '下载模板失败',
                searchFail: '搜索失败',
                uploadFileTypeError: '只能上传Excel文件!',
                uploadFileSizeError: '文件大小不能超过10MB!',
                uploadFileSuccess: '文件上传成功!',
                uploadFileFail: '文件上传失败，请重试',
                uploadDataAllDone: '数据上传完成，所有配置已完成！您可以关闭此弹窗。',
                clearDataSuccess: '数据清空成功',
                clearDataFail: '清空数据失败',
                saveDataConfigSuccess: '数据配置保存成功',
                saveDataConfigFail: '保存数据配置失败'
            },
            nav: {
                prev: '上一步',
                next: '下一步',
                complete: '完成'
            }
        },
        changeType: '修改题型',
        copyOptions: {
            title: '复制选项',
            currentQuestion: '当前题',
            sourceQuestion: '来源题',
            sourcePlaceholder: '请选择来源题',
            rulesTitle: '题型选项复制规则',
            ruleSingleMultiSort: '单选题 ↔ 复选题 ↔ 排序题',
            ruleMatrix: '矩阵单选题 ↔ 矩阵多选题 ↔ 矩阵统计题 ↔ 矩阵填空题',
            notSetTitle: '未设置题目',
            success: '选项复制成功',
            failWithMsg: '复制失败：{msg}',
            notFoundSource: '未找到来源题：{qno}',
            notFoundTarget: '未找到目标题：{qno}',
            failGeneral: '复制选项失败：{msg}'
        },
        changeTypeDialog: {
            title: '修改题型',
            currentQuestion: '当前题',
            currentType: '当前题型',
            targetType: '目标题型',
            targetPlaceholder: '请选择目标题型'
        },
        selectQuestionFirst: '请先选择一个问题',
        changeTypeMessages: {
            notSelected: '未选中题目',
            noSupport: '该题型不支持直接转换',
            sameType: '目标题型与当前一致，无需修改',
            success: '修改题型成功',
            failedWithMsg: '修改失败：{msg}',
            failedGeneral: '修改题型失败：{msg}'
        },
        currentQuestionLabel: '当前题目：',
        copyLogic: {
            title: '逻辑',
            sourceQuestion: '来源题',
            sourcePlaceholder: '请选择来源题',
            promptTitle: '复制逻辑',
            promptMessage: '请输入来源题题号（如：Q5）',
            selectSourceTip: '请选择来源题',
            noSource: '未获取到来源题逻辑',
            sourceEmpty: '来源题暂无逻辑',
            fail: '复制逻辑失败',
            failWithMsg: '复制逻辑失败：{msg}',
            projectIdMissing: '项目ID缺失，无法复制逻辑',
            typeMismatchConfirmTitle: '类型不一致',
            typeMismatchConfirm: '来源题({source})类型为 {sourceType}，与目标题({target})类型 {targetType} 不一致，仍要覆盖保存吗？',
            notFoundSource: '未找到来源题：{qno}'
        },
    },
    profileView: {
        title: '个人信息',
        back: '返回',
        edit: '编辑',
        save: '保存',
        cancel: '取消',
        username: '用户名',
        avatar: '头像',
        changeAvatar: '更换头像',
        email: '邮箱',
        phone: '手机号',
        usernameRequired: '请输入用户名',
        usernameLength: '长度在 3 到 20 个字符',
        emailRequired: '请输入邮箱地址',
        emailFormat: '请输入正确的邮箱地址',
        phoneRequired: '请输入手机号',
        phoneFormat: '请输入正确的手机号',
        saveSuccess: '保存成功',
        saveFail: '保存失败',
        avatarTypeError: '上传头像图片只能是 JPG 格式!',
        avatarSizeError: '上传头像图片大小不能超过 2MB!',
    },
    notFound: {
        title: '404',
        pageNotFound: '页面未找到',
        searching: '我们正在努力寻找您想要的页面...',
        backHome: '返回首页',
    },
    iconSelect: {
        placeholder: '请输入图标名称',
    },
    tinymce: {
        placeholder: '在这里输入文字',
    },
    favoritesCenter: {
        title: '收藏中心',
        subtitle: '管理你的题目和脚本收藏',
        add: '新增收藏',
        name: '名称',
        type: '类型',
        content: '内容',
        scope: '范围',
        personal: '个人',
        public: '公共',
        question: '题目',
        script: '脚本',
        scriptType: '脚本类型',
        scriptTypeBefore: '执行前',
        scriptTypeMiddle: '执行中',
        scriptTypeAfter: '执行后',
        tag: '标签',
        remark: '备注',
        uploader: '上传人',
        createTime: '创建时间',
        actions: '操作',
        edit: '编辑',
        delete: '删除',
        collect: '收藏',
        approve: '通过',
        reject: '拒绝',
        filterName: '收藏名称',
        filterType: '类型',
        filterScope: '范围',
        filterSearch: '查询',
        dialogAdd: '新增收藏',
        dialogEdit: '编辑收藏',
        dialogUneditable: '题目收藏不可编辑',
        dialogCancel: '取消',
        dialogConfirm: '确定',
        deleteConfirm: '确定删除该收藏吗？',
        deleteSuccess: '删除成功',
        deleteFail: '删除失败',
        addSuccess: '新增成功',
        editSuccess: '编辑成功',
        collectConfirm: '确定收藏该{type}到个人收藏吗？',
        collectSuccess: '{type}收藏成功',
        collectFail: '收藏失败: {msg}',
        personalCollect: '个人收藏',
        publicCollect: '公共收藏',
        pendingAudit: '待审核',
        approvedPublic: '已转公',
        auditEdit: '审核编辑',
        auditSuccess: '审核成功',
        rejectConfirm: '确定拒绝该转公申请吗？',
        noEditTip: '题目收藏不可编辑',
        scriptScope: '脚本范围',
        personalScript: '个人脚本',
        publicScript: '公共脚本',
        personalScriptTip: '仅自己可见',
        publicScriptTip: '所有用户可见',
        page: '页码',
        pageSize: '每页条数',
    },
    brands: {
        common: {
            all: '全部',
            id: 'ID',
            actions: '操作',
            search: '搜索',
            reset: '重置',
            refresh: '刷新',
            edit: '编辑',
            delete: '删除',
            save: '保存',
            cancel: '取消',
            tip: '提示',
            saveFail: '保存失败',
            deleteFail: '删除失败'
        },
        category: {
            title: '词条分类',
            create: '新增分类',
            listTitle: '分类列表',
            onlyTop: '仅显示一级',
            searchPlaceholder: '搜索分类名称',
            parentPlaceholder: '一级分类',
            childPlaceholder: '二级分类',
            level1: '一级',
            level2: '二级',
            columns: {
                name: '分类名称',
                level: '层级',
                parent: '父分类'
            },
            createTitle: '新增分类',
            editTitle: '编辑分类',
            deleteConfirmMessage: '确认删除该分类吗？',
            form: {
                name: '分类名称',
                level: '层级',
                parent: '父分类',
                levelPlaceholder: '请选择层级',
                parentPlaceholder: '二级分类必须选择父分类',
                nameRequired: '请输入分类名称',
                levelRequired: '请选择层级',
                parentRequired: '二级分类必须选择父分类'
            }
        }
    },
    selectQuestionFirst: '请先选择一个问题',
    pricing: {
        login: '登录',
        register: '注册',
        heroTitle: '选择适合您的版本',
        heroSubtitle: '灵活的定价方案，满足不同规模企业的需求',
        year: '年',
        yearFrom: '年起',
        recommended: '推荐',
        buyNow: '立即购买',
        contactSales: '联系销售',
        freeTrial: '免费试用',
        contactMsg: '请通过客服热线或在线客服联系我们获取更多信息',
        heroEyebrow: 'YiSurvey Pricing',
        heroLine1: '按调研产能，',
        heroLine2: '选择适合',
        heroLine3: '团队的方案。',
        heroDescription: '把预算换成清晰可交付的问卷额度、回收能力、分析深度和部署方式。标准版、尊享版、旗舰版分别对应日常调研、自建研究团队和大型组织部署。',
        purchasePathLabel: '购买路径',
        routeCapabilities: '产品能力',
        routePlans: '价格方案',
        routeSales: '联系销售',
        viewPlans: '查看方案',
        proposalIndex: '方案索引',
        proposal: {
            standard: '10万答卷 / 5个子账号',
            premium: '20万答卷 / AI洞察分析',
            flagship: '30万答卷 / 本地化部署',
            flagshipPrice: '¥45,368 起'
        },
        axis: {
            design: '设计',
            send: '发送',
            collect: '回收',
            analyze: '分析',
            integrate: '集成'
        },
        capacityTitle: '问卷创建 / 样本回收 / 数据交付',
        capacityDescription: '每档方案都对应一条完整调研链路，只是在规模、自动化能力和交付深度上逐级增强。',
        plansEyebrow: 'Plans',
        plansTitle: '三档方案，覆盖从中小企业到本地化部署。',
        comparisonRailTitle: '详细功能对比',
        answerQuota: '答卷额度',
        administrators: '管理员',
        deliveryFocus: '交付重点',
        matrixEyebrow: 'Capability Matrix',
        comparisonDescription: '按设计、发送、回收、分析和系统集成拆开比较，方便采购、业务和技术团队一起判断。',
        helpEyebrow: 'Need Help?',
        ctaDescription: '立即注册即可免费体验企业标准版功能；如果需要本地化部署、发票或合同条款，可以直接联系销售。',
        footerCopyright: '易调研系统 YiSurvey. All rights reserved.',
        backHome: '返回首页',
        emailSubject: '咨询易调研系统价格方案',
        emailBody: '您好，我想了解易调研系统的价格方案，请联系我。',
        standard: {
            name: '企业标准版',
            desc: '适合中小企业',
            kicker: 'Standard Capacity',
            answerCap: '10万份',
            adminCap: '5个子账号',
            serviceCap: '基础服务',
            f1: '每日创建问卷100份',
            f2: '回收答卷10万份',
            f3: '赠送5个子账号管理员',
            f4: '专属服务顾问 + 基础考试',
            f5: '基础数据分析'
        },
        premium: {
            name: '企业尊享版',
            desc: '适合中大型企业',
            kicker: 'Recommended',
            answerCap: '20万份',
            adminCap: '5个子账号',
            serviceCap: 'AI洞察',
            f1: '问卷创建数量无限制',
            f2: '回收答卷20万份（可扩增）',
            f3: '赠送5个子账号管理员',
            f4: '品牌自定义 + 360°测评',
            f5: '完整考试 + AI洞察分析'
        },
        flagship: {
            name: '企业旗舰版',
            desc: '适合大型企业/政府/高校',
            kicker: 'Enterprise Deployment',
            answerCap: '30万份',
            adminCap: '10个子账号',
            serviceCap: '本地化',
            f1: '问卷创建数量无限制',
            f2: '回收答卷30万份（可扩增）',
            f3: '赠送10个子账号管理员',
            f4: '金牌服务顾问 + 本地化部署',
            f5: 'CSS/JS自定义 + 多语言定制'
        },
        comparisonTitle: '详细功能对比',
        colFeature: '功能',
        ctaTitle: '还没想好选择哪个版本？',
        ctaSubtitle: '立即注册即可免费体验企业标准版功能',
        group: {
            design: '设计问卷',
            send: '发送问卷',
            collection: '回收答卷',
            analysis: '数据分析',
            satisfaction: '解决方案-满意度评估',
            systemIntegration: '系统集成'
        },
        row: {
            surveyLimit: '可发布/可创建问卷数量',
            validPeriod: '单份问卷填写有效期',
            questionTypes: '题型',
            logicRelation: '逻辑关系',
            formula: '计算公式',
            quota: '设置配额',
            passwordProtect: '问卷密码保护',
            conditionalAction: '答题完成后按条件处理',
            duplicateCheck: '重复填写限制',
            breakpointResume: '断点续答',
            externalQuery: '对外查询功能',
            modifyAnswer: '填写者修改答卷',
            pageTimer: '控制填写页面时间',
            webEmbed: '网站集成',
            emailSend: '邮件发送',
            transferSurvey: '转移问卷',
            customSource: '自定义来源',
            customUrlParam: '自定义链接参数',
            maxAnswers: '单份问卷最大填写人次',
            fileSpace: '上传文件题空间',
            autoFilterInvalid: '使用规则自动筛选无效答卷',
            downloadReport: '下载调查报告(Word/Excel/SPSS格式)',
            exportWord: '导出答案到Word/PDF',
            customWordExport: '自定义word模板导出',
            batchDownload: '附件批量下载',
            shareData: '分享详细数据',
            sampleService: '样本服务(收费)',
            crossAnalysis: '交叉对比分析',
            sourceAnalysis: '答卷来源分析',
            completionRate: '完成率分析',
            npsScore: 'NPS净推荐值',
            npsTrend: 'NPS变化趋势',
            swotAnalysis: '维度指标SWOT分析',
            industryCompare: '行业对比',
            multiLevelReport: '多层级报告',
            lowScoreAlert: '低分预警',
            quantitativeAnalysis: '量化分析',
            regionTimeCompare: '地区/时间线对比',
            factorCompare: '影响因子对比',
            dedicatedCloudServer: '独立租户云服务器',
            privateCloudServer: '私有云服务器'
        },
        val: {
            surveyLimitStd: '总份数无限制(每天最多100份)',
            unlimited: '无限制',
            partialTypes: '部分高级题型不支持',
            logicRef: '跳题/关联(题目、选项)引用',
            formulaOne: '仅支持一个公式',
            quota50k: '答卷数超过50000，配额规则将不再生效。每个问卷最多添加50个生效的配额规则',
            pwd50k: '√(5万)',
            pwd500k: '√(50万)',
            resumeLocal: '仅本地',
            resumeNetwork: '支持本地、网络断点续答',
            query5k: '数据5000',
            query20w: '数据20万',
            param1: '一个参数',
            paramMulti: '多参数带入且支持加密',
            email60: '最快60封/小时',
            email300: '最快300封/小时',
            source100: '最多100个',
            source30k: '最多30000个',
            answers10w: '10万',
            answers20w: '20万',
            space24g: '24G/年|2G/月',
            space120g: '120G/年|15G/月',
            space240g: '240G/年|20G/月',
            export2000: '最多2000份',
            export2w: '最多2万份',
            export10w: '最多10万份',
            cross4: '4个条件',
            cross10: '查询最多支持10个条件',
            completionNote: '问卷创建于最近6个月内，且最近3个月内至少有一次访问',
            tenThousand: '万',
            customPaid: '可定制，另外付费'
        }
    },
    request: {
        kickedOut: '您的账号已在别处登录，您已被迫下线。如非本人操作，请及时修改密码。',
        badRequest: '请求参数有误，请检查填写内容',
        forbidden: '没有权限执行该操作',
        notFound: '请求的内容不存在或已被删除',
        timeout: '请求超时，请检查网络后重试',
        payloadTooLarge: '上传内容过大，请压缩后重试',
        tooManyRequests: '操作太频繁，请稍后再试',
        serverError: '服务器处理失败，请稍后重试',
        serviceUnavailable: '服务暂时不可用，请稍后重试',
        failedWithStatus: '请求失败（{status}），请稍后重试',
        networkError: '网络连接异常，请检查网络后重试'
    }
}
